//
// Valstream video player.
function ValstreamVideoPlayer(options){

    // Validate options.
    if(!options.hasOwnProperty('videoJsLibrary')
        || !options.videoJsLibrary
        || typeof options.videoJsLibrary !== 'function'
        || !options.hasOwnProperty('elementId')
        || !options.elementId
        || typeof options.elementId !== 'string'
    ){

        throw new Error('Unable to configure Valstream video player, one or more required parameters are missing or invalid.');
    }

    // Constants
    this.DEFAULT_AUTO_NAV_TIME_IN_MILLISECONDS_NEXT_VIDEO_PROMPT     = 13 * 1000;
    this.DEFAULT_AUTO_NAV_TIME_IN_MILLISECONDS_NEXT_VIDEO_TRANSITION = 7 * 1000;
    this.DEFAULT_PREROLL_TIMEOUT_IN_MILLISECONDS                     = 8000;
    this.DEFAULT_MAX_AD_ERROR_RETRIES                                = 2;
    this.DEFAULT_MAX_AD_PREROLL_COUNT                                = 2;
    this.DEFAULT_MAX_AD_PREROLL_COUNT_NO_AUTOPLAY                    = 1;
    this.DEFAULT_ALLOW_SKIP_COUNTDOWN_PAUSE                          = false;
    this.DEFAULT_SHOW_TITLE                                          = false;
    this.DEFAULT_SHOW_CLICK_THROUGH_BUTTON                           = false;
    this.DEFAULT_CHANGING_VIDEO_DETAILS                              = false;
    this.DEFAULT_SHOW_OVERLAYS                                       = false;
    this.DEFAULT_ALLOW_AUTOPLAY                                      = true;
    this.DEFAULT_ALLOW_AUTOPLAY_WHEN_IN_VIEW                         = true;
    this.MODE_LAYOUT_FLUID                                           = 1;
    this.MODE_LAYOUT_FILL                                            = 2;
    this.DEFAULT_DELAY_AFTER_AD_SKIPPED_IN_MILLISECONDS              = 0;
    this.DEFAULT_DELAY_AFTER_AD_CLOSED_IN_MILLISECONDS               = 0;
    this.DEFAULT_USE_LARGE_UNMUTE_BUTTON                             = false;
    this.DEFAULT_SOUND_ON                                            = false;
    this.DEFAULT_REQUEST_DELAY_NO_AD_FILL_IN_MILLISECONDS            = 2000;
    this.DEFAULT_REQUEST_DELAY_AD_ERROR_IN_MILLISECONDS              = 5000;
    this.DEFAULT_FORCE_AD_SKIP_TIMEOUT_IN_SECONDS                    = 15;
    this.DEFAULT_ASPECT_RATIO                                        = '16:9';

    this.allowAutoplay                                = (typeof options.allowAutoplay == 'boolean') ? options.allowAutoplay : this.DEFAULT_ALLOW_AUTOPLAY;
    this.allowAutoplayWhenInView                      = (typeof options.allowAutoplayWhenInView == 'boolean') ? options.allowAutoplayWhenInView : this.DEFAULT_ALLOW_AUTOPLAY_WHEN_IN_VIEW; // If you want to allow video to continue playing when not in view set to false.
    this.aspectRatio                                  = options.aspectRatio || this.DEFAULT_ASPECT_RATIO;
    this.maxAdErrorRetries                            = options.maxAdErrorRetries || this.DEFAULT_MAX_AD_ERROR_RETRIES;
    this.autoNavTimeInMillisecondsNextVideoPrompt     = options.autoNavTimeInMillisecondsNextVideoPrompt || this.DEFAULT_AUTO_NAV_TIME_IN_MILLISECONDS_NEXT_VIDEO_PROMPT;
    this.autoNavTimeInMillisecondsNextVideoTransition = options.autoNavTimeInMillisecondsNextVideoTransition || this.DEFAULT_AUTO_NAV_TIME_IN_MILLISECONDS_NEXT_VIDEO_TRANSITION;
    this.allowAutoPlaylistNavigation                  = (typeof options.allowAutoPlaylistNavigation == 'boolean') ? options.allowAutoPlaylistNavigation : this.allowAutoplay;
    this.prerollTimeoutInMilliseconds                 = options.prerollTimeoutInMilliseconds || this.DEFAULT_PREROLL_TIMEOUT_IN_MILLISECONDS;
    this.allowSkipCountdownPause                      = options.allowSkipCountdownPause || this.DEFAULT_ALLOW_SKIP_COUNTDOWN_PAUSE;
    this.googleAnalytics                              = options.googleAnalytics;
    this.videoJsLibrary                               = options.videoJsLibrary;
    this.biddingManager                               = options.biddingManager;
    this.googleLibrary                                = options.googleLibrary;
    this.logger                                       = options.logger || new window.ValstreamLogger();
    this.eventHelper                                  = options.eventHelper || new window.AdsNinjaVideoPlayerEventHelper();
    this.__allowAds                                   = (typeof options.allowAds == 'boolean') ? options.allowAds : (options.googleLibrary && typeof options.googleLibrary.ima !== 'undefined' && options.biddingManager && typeof options.biddingManager !== 'undefined');
    this.__isEnabledAds                               = this.__allowAds; // TODO: Make option.
    this.modeLayout                                   = options.modeLayout || this.MODE_LAYOUT_FLUID;
    this.__autoplay                                   = (typeof options.autoplay == 'boolean') ? options.autoplay : this.DEFAULT_ALLOW_AUTOPLAY;
    this.allowBackgroundPlay                          = false; // TODO: When asked for can play and not pause. Supersedes autoplay check in relevant instances when user clicked play.
    this.isFirstVideo                                 = true;
    this.usedSecondAuction                            = false;
    this.videoAdQueue                                 = [];
    this.userAllowedPlayingVideos                     = false;
    this.firstPlay                                    = true;
    this.showTitle                                    = (typeof options.showTitle == 'boolean') ?  options.showTitle : this.DEFAULT_SHOW_TITLE;
    this.showClickThroughButton                       = (typeof options.showClickThroughButton == 'boolean') ? options.showClickThroughButton : this.DEFAULT_SHOW_CLICK_THROUGH_BUTTON;
    this.changingVideoDetails                         = (typeof options.changingVideoDetails == 'boolean') ? options.changingVideoDetails : this.DEFAULT_CHANGING_VIDEO_DETAILS;
    this.showOverlays                                 = (typeof options.showOverlays == 'boolean') ? options.showOverlays : this.DEFAULT_SHOW_OVERLAYS;
    this.delayAfterAdSkippedInMilliseconds            = options.delayAfterAdSkippedInMilliseconds || this.DEFAULT_DELAY_AFTER_AD_SKIPPED_IN_MILLISECONDS;
    this.delayAfterAdClosedInMilliseconds             = options.delayAfterAdClosedInMilliseconds || this.DEFAULT_DELAY_AFTER_AD_CLOSED_IN_MILLISECONDS;
    this.__adsLoaderQueue                             = [];
    this.__firstAdsLoaderQueueProcessing              = true;
    this.__useLargeSoundToggleButton                  = (typeof options.useLargeSoundToggleButton == 'boolean') ? options.useLargeSoundToggleButton : this.DEFAULT_USE_LARGE_UNMUTE_BUTTON; 
    this.__soundOn                                    = (typeof options.soundOn == 'boolean') ? options.soundOn : this.DEFAULT_SOUND_ON;
    this.__requestDelayNoAdFillInMilliseconds         = options.requestDelayNoAdFillInMilliseconds || this.DEFAULT_REQUEST_DELAY_NO_AD_FILL_IN_MILLISECONDS;
    this.requestDelayAdErrorInMilliseconds            = options.requestDelayAdErrorInMilliseconds || this.DEFAULT_REQUEST_DELAY_AD_ERROR_IN_MILLISECONDS;
    this.__forceAdSkip                                = (typeof options.forceAdSkip == 'boolean') ? options.forceAdSkip : false;
    this.__forceAdSkipTimeoutInSeconds                = options.forceAdSkipTimeoutInSeconds || this.DEFAULT_FORCE_AD_SKIP_TIMEOUT_IN_SECONDS;
    this.__renderAdWithReponseOverTag                 = (typeof options.renderAdWithReponseOverTag == 'boolean') ? options.renderAdWithReponseOverTag : false;
    this.__externalFloatControl                       = (typeof options.externalFloatControl == 'boolean') ? options.externalFloatControl : true;

    //
    // State to track if sticky video has been closed.
    this.stickyClosed = false;

    //
    // State to track if video has been in viewport yet.
    this.intersectedViewport = false;

    //
    // State to track if an ad is playing.
    this.adPlaying = false;

    //
    // State to track current creative ids being played
    this.currentCreativeIds = [];

    //
    // State to track current ad wrapper systems being played
    this.currentAdWrapperSystems = [];

    //
    // State to track number of pre-rolls played.
    this.prerollCount = 0;

    //
    // VideoJS instance.
    this.player  = null;

    //
    // Tracks the auto navigation feature triggering timeout.
    this.autoNavTimeout = null;

    //
    // Tracks the auto next feature triggering timeout.
    this.autoNextTimeout = null;

    //
    // Tracks ad error retries.
    this.adErrorRetries = 0;

    //
    // Init state of ad display container.
    this.adDisplayInitialized = false;

    //
    // Visibility state of player
    this.isVisible = false;

    //
    // State to track time on page.
    this.duration = 0;

    //
    // State to track time on page when player is visible.
    this.viewableDuration = 0;

    this.elementId                                          = options.elementId;
    this.adElement                                          = null;
    this.videoPlayerElement                                 = null;
    this.largeSoundToggleButtonElement                      = null;
    this.muteButtonElement                                  = null;
    this.videoContainer                                     = null;
    this.videoContainerInner                                = null;
    this.autoNav                                            = null;
    this.autoNavNext                                        = null;
    this.autoNavStay                                        = null;
    this.video                                              = null;
    this.playlistVideoUrls                                  = options.playlistVideoUrls; // For compatibility.
    this.playlist                                           = options.playlist;
    this.videoContainerInnerWidth                           = null;
    this.videoContainerInnerHeight                          = null;
    this.adSkipNext                                         = null;
    this.adSkipButton                                       = null;
    this.adSkipCountdown                                    = null;
    this.googleImaAdManager                                 = null;
    this.adSkipInterval                                     = null;
    this.adSkipCountdownEneabled                            = true;
    this.titleElement                                       = null;
    this.trackingVideoProgressStarted                       = false;
    this.videoTitleElementIsHidden                          = false;
    this.trackingVideoProgressStartedAfterPrerollAds        = false;
    this.trackingVideoProgressThresholdPassedFirst          = false;
    this.trackingVideoProgressThresholdPassedSecond         = false;
    this.trackingVideoProgressThresholdPassedThird          = false;
    this.trackingVideoProgressThresholdPassedForth          = false;
    this.trackingVideoProgressThresholdPassedMidrollAuction = false;
    this.trackingVideoProgressThresholdPassedMidrollRequest = false;
    this.trackingVideoProgressSeeked                        = false;
    this.trackingVideoProgressEnded                         = false;
    this.trackingPlay                                       = false;
    this.adErrorRetriesExhausted                            = false;
    this.adMuteElement                                      = null;
    this.adVolumeSliderLevelElement                         = null;
    this.videoDetailsElement                                = null;
    this.descriptionElement                                 = null;
    this.overlayTitleElement                                = null;
    this.overlayDurationElement                             = null;
    this.isSeeking                                          = false;
    this.hasSought                                          = false;
    this.currentPlaylistItem                                = (this.playlist && Array.isArray(this.playlist) && this.playlist.length > 0) ? this.playlist[0] : null;
    this.initialized                                        = false;
    this.eventLog                                           = {};
    this.currentPlacement                                   = 'preroll';
    this.midRollUpcoming                                    = false;
    this.resumingTimeStamp                                  = null;
    this.adFinishing                                        = false;
    this.numberOfMidrolls                                   = 0;
    this.hasPlaylist                                        = false;
    this.adStarting                                         = false;
    this.recordedAdImpression                               = false;
    this.videoType                                          = options.videoType;
    this.maxPrerollAdCount                                  = null;
    this.midrollThresholdAuction                            = null;
    this.midrollThresholdRequest                            = null;
    this.baseMidrollThresholdAuction                        = null;
    this.baseMidrollThresholdRequest                        = null;
    this.nextMidrollThresholdAuction                        = null;
    this.nextMidrollThresholdRequest                        = null;
    this.midrollIntervalMax                                 = null;
    this.midrollIntervalMultiplier                          = null;
    this.hasPreparedForNextPlayback                         = false;
    this.playerIsTransitioning                              = false;
    this.registeredEventListenersOnPlay                     = false;
    this.firstClickEventHandler                             = null;
    this.queue                                              = [];
    this.__firstQueueProcessing                             = true;
    this.__initialized                                      = false;
    this.requestedTextTrack                                 = null;
    this.hasTextTracks                                      = false;
    this.handledFirstClickEvent                             = false;
    this.videoPlayFailsafe                                  = null;
    this.__geo                                              = null;
    this.__isPrimeGeo                                       = null;
    this.__totalAdRenderAttempts                            = 0;
    var self                                                = this;

    this.setAdSchedule(options.adSchedule || null);

    this.__init();
    this.__registerEventListeners();

    if('instream' === this.videoType){

        this.engagementHelper = new window.AdsNinjaVideoPlayerEngagementHelper(this.adElement, [3], function(time){

            // self.recordSentinelEvent(`Engaged${time}sec`);
            self.recordSentinelEvent(`Engaged5sec`);
        });
    }
}

//
// Get element id.
ValstreamVideoPlayer.prototype.getElementId = function(){
    
    return this.elementId;
}


//
// Play.
ValstreamVideoPlayer.prototype.play = function(context = 'programmatic') {

    this.logger.debug('Playback: attempting to play.', {
        elementId: this.elementId,
    });

    if(!this.__initialized){

        var self = this;

        this.queue.push(function(){

            self.play(context);
        });

        this.logger.debug('Playback: player not fully initialized or is processing previous requests, queueing request.', {
            elementId: this.elementId,
        });

        return false;
    }

    if(!this.player){

        this.logger.error('Playback: failed to play.', {
            elementId: this.elementId,
        });

        return false;
    }

    try{

        if(!this.trackingPlay){

            this.trackingPlay = true;

            this.recordSentinelEvent('Play');
        }

        if(this.isEnabledAds() && this.adPlaying){

            this.player.ima.resumeAd();
            this.notifyAdIsReadyToPlay();
        }
        else{

            if(!this.hasPlaylist){


                this.prepareForNextPlayback();  // Try to do this in case it wasn't already prepared.
            }

            if(this.isAllowedToPlayAds() && this.isFirstVideo && this.firstPlay){

                this.beginAdTransition();
            }
            
            this.player.play();

            if(this.isAutoplayEnabled()){

                this.startAutoNav();
            }
        }

        this.logger.debug('Playback: resuming.', {
            elementId: this.elementId,
            isAdPlaying: this.adPlaying,
        });

        this.annonceEvent('play');

        return true;
    }
    catch(error){

        this.logger.error('Playback: failed to play.', {
            elementId: this.elementId,
            error: error,
        });

        return false;
    }
}

//
// Pause.
ValstreamVideoPlayer.prototype.pause = function(context = 'programmatic'){

    this.logger.debug('Playback: attempting to pause.', {
        elementId: this.elementId,
    });

    if(!this.__initialized){

        var self = this;

        this.queue.push(function(){

            self.pause(context);
        });

        this.logger.debug('Playback: player not fully initialized or is processing previous requests, queueing request.', {
            elementId: this.elementId,
        });

        return false;
    }

    if(!this.player){

        this.logger.error('Playback: failed to pause.', {
            elementId: this.elementId,
        });

        return false;
    }

    try{

        if(this.isEnabledAds() && this.inAdBreak()){

            this.player.ima.pauseAd();
        }
        else{

            this.player.pause();
            this.cancelAutoNav();
        }

        this.logger.debug('Playback: pausing.', {
            elementId: this.elementId,
            isAdPlaying: this.adPlaying,
        });

        this.annonceEvent('pause'); 

        return true;
    }
    catch(error){

        this.logger.error('Playback: failed to pause.', {
            elementId: this.elementId,
            error: error,
        });

        return false;
    }
}

//
// Mute.
ValstreamVideoPlayer.prototype.mute = function(context = 'programmatic'){

    this.logger.debug('Sound: attempting to mute.', {
        elementId: this.elementId,
    });

    if(!this.__initialized){

        var self = this;

        this.queue.push(function(){

            self.mute(context);
        });

        this.logger.debug('Sound: player not fully initialized or is processing previous requests, queueing request.', {
            elementId: this.elementId,
        });

        return false;
    }

    try{

        var result = this.__setVolume(0);

        if(!result){

            this.logger.error('Sound: failed to mute.', {
                elementId: this.elementId,
                error: error,
            });    
        }
        else{

            this.logger.debug('Sound: muting.', {
                elementId: this.elementId,
                isAdPlaying: this.adPlaying,
            });
    
            // this.annonceEvent('mute'); 
        }

        return result;
    }
    catch(error){

        this.logger.error('Sound: failed to mute.', {
            elementId: this.elementId,
            error: error,
        });

        return false;
    }
}

//
// Un-mute.
ValstreamVideoPlayer.prototype.unmute = function(context = 'programmatic'){

    this.logger.debug('Sound: attempting to unmute.', {
        elementId: this.elementId,
    });

    if(!this.__initialized){

        var self = this;

        this.queue.push(function(){

            self.unmute(context);
        });

        this.logger.debug('Sound: player not fully initialized or is processing previous requests, queueing request.', {
            elementId: this.elementId,
        });

        return false;
    }

    if(!this.player){

        this.logger.error('Sound: failed to unmute.', {
            elementId: this.elementId,
        });

        return false;
    }

    try{

        var volume = this.player.volume();
        var result = this.__setVolume(volume);

        if(!result){

            this.logger.error('Sound: failed to unmute.', {
                elementId: this.elementId,
                error: error,
            });
        }
        else{

            this.logger.debug('Sound: unmuting.', {
                elementId: this.elementId,
                isAdPlaying: this.adPlaying,
            });
    
            // this.annonceEvent('unmute'); 
        }

        return result;
    }
    catch(error){

        this.logger.error('Sound: failed to unmute.', {
            elementId: this.elementId,
            error: error,
        });

        return false;
    }
}

//
// Sets the volume.
ValstreamVideoPlayer.prototype.setVolume = function(volume, context = 'programmatic'){

    this.logger.debug('Sound: attempting to set volume.', {
        elementId: this.elementId,
    });

    if(!this.__initialized){

        var self = this;

        this.queue.push(function(){

            self.setVolume(volume, context);
        });

        this.logger.debug('Sound: player not fully initialized or is processing previous requests, queueing request.', {
            elementId: this.elementId,
        });

        return false;
    }

    // Validate volume.
    if(typeof volume !== 'number' || volume < 0 || volume > 100){

        this.logger.error('Sound: failed to set volume. Invalid volume value provided.', {
            volume: volume,
        });

        return false;
    }

    try{

        var result = false;

        if(0 === volume){

            result = this.mute();
        }
        else{

            result = this.__setVolume(volume / 100);
        }

        if(!result){
            
            this.logger.error('Sound: failed to set volume.', {
                elementId: this.elementId,
                error: error,
            });
        }
        else{

            this.logger.debug('Sound: setting volume.', {
                elementId: this.elementId,
                isAdPlaying: this.adPlaying,
            });
    
            // this.annonceEvent('volumeSet'); 
        }

        return result;
    }
    catch(error){

        this.logger.error('Sound: failed to set volume.', {
            elementId: this.elementId,
            error: error,
        });

        return false;
    }
}

//
// Enable text track.
ValstreamVideoPlayer.prototype.enableTextTrack = function(kind, language, context = 'programmatic'){

    this.logger.debug('Text track: attempting to enable text track.', {
        elementId: this.elementId,
        kind: kind,
        language: language,
    });

    // Validate parameters.
    if(typeof kind !== 'string' || typeof language !== 'string'){

        this.logger.error('Text track: failed to enable text track. Invalid parameters provided.', {
            elementId: this.elementId,
            kind: kind,
            language: language,
        });

        return false;
    }

    if(!this.__initialized){

        var self = this;

        this.queue.push(function(){

            self.enableTextTrack(kind, language, context);
        });

        this.logger.debug('Text track: player not fully initialized or is processing previous requests, queueing request.', {
            elementId: this.elementId,
        });

        return false;
    }

    // No need to add text tracks if there are none.
    if(!this.hasTextTracks){

        this.logger.debug('Text track: failed to enable text track. No text tracks provided.');

        this.requestedTextTrack = null;

        return false;
    }

    this.requestedTextTrack = { kind: kind, language: language, };
    
    if(this.adPlaying){

        this.logger.debug('Text track: failed to enable text track. Ad is playing. Will attempt to enable text track later.', {
            elementId: this.elementId,
            kind: kind,
            language: language,
        });

        return false;
    }

    try{

        // Get all text tracks for the player.
        var tracks = this.player.textTracks();

        if(!tracks || tracks.length === 0){
            
            this.logger.warn('Text track: failed to enable text track. No text tracks found. Will attempt to enable text track later.', {
                elementId: this.elementId,
                kind: kind,
                language: language,
            });

            return false;
        }

        var found = false;

        for(var i = 0; i < tracks.length; i++){
        
            var track = tracks[i];
        
            if(track.kind === kind && track.language === language){

                track.mode = 'showing';
                found      = true;
            }
            else{

                track.mode = 'disabled';
            }
        }
        
        if(found){

            this.logger.debug('Text track: enabled text track.', {
                elementId: this.elementId,
                kind: kind,
                language: language,
            });

            this.requestedTextTrack = null;

            return true;
        }

        this.logger.debug('Text track: failed to enable text track. Text track not found. Will attempt to enable text track later.', {
            elementId: this.elementId,
            kind: kind,
            language: language,
        });

        return false;
    }
    catch(error){

        this.logger.error('Text track: failed to enable text track.', {
            elementId: this.elementId,
            kind: kind,
            language: language,
            error: error,
        });

        return false;
    }
}

//
// Disable text track.
ValstreamVideoPlayer.prototype.disableTextTrack = function(context = 'programmatic'){

    this.logger.debug('Text track: attempting to disable text track.', {
        elementId: this.elementId,
    });

    if(!this.__initialized){

        var self = this;

        this.queue.push(function(){

            self.disableTextTrack(context);
        });

        this.logger.debug('Text track: player not fully initialized or is processing previous requests, queueing request.', {
            elementId: this.elementId,
        });

        return false;
    }

    try{

        // Get all text tracks for the player.
        var tracks = this.player.textTracks();

        if(!tracks || tracks.length === 0){
            
            this.logger.warn('Text track: failed to disable text track. No text tracks found.', {
                elementId: this.elementId,
            });

            return false;
        }

        for(var i = 0; i < tracks.length; i++){
        
            var track  = tracks[i];
            track.mode = 'disabled';
        }

        this.requestedTextTrack = null;

        return true;
    }
    catch(error){

        this.logger.error('Text track: failed to disable text track.', {
            elementId: this.elementId,
            error: error,
        });

        return false;
    }
}

//
// Renders an ad.
ValstreamVideoPlayer.prototype.addAdToQueue = function(videoUrl, placement){

    this.videoAdQueue.push(videoUrl);
};

//
// Renders an ad.
ValstreamVideoPlayer.prototype.renderAd = function(videoUrl, placement, ignoreInAdBreak = false){

    this.__totalAdRenderAttempts++;

    if(!videoUrl){

        if('preroll' === placement){

            this.prerollCount++;
        }

        this.logger.debug('No ad to display. ', {
            videoUrl: videoUrl,
        });

        this.handleAdDone();

        if(!this.hasPlaylist){

            this.prepareForNextPlayback(this.__requestDelayNoAdFillInMilliseconds);
        }

        return;
    }

    if(!ignoreInAdBreak && this.player.hasOwnProperty('ads') && 'object' === typeof this.player.ads && this.inAdBreak()){

        this.videoAdQueue.push(videoUrl);
        return;
    }

    this.resumingTimeStamp = null;

    if('preroll' === placement){

        this.prerollCount++;
    }
    else{

        this.resumingTimeStamp = this.player.currentTime();
    }

    this.__renderAd(videoUrl);
};

//
// Render ad helper.
ValstreamVideoPlayer.prototype.__renderAd = function(videoUrl){

    var vpaParam = 0;


    if(!videoUrl){

        throw new Error('Invalid URL provided.');
    }

    this.logger.debug('Video ad url. ', {
        videoUrl: videoUrl,
    });

    if(this.isAutoplayEnabled()){

        vpaParam = 1;
    }

    this.setVideoVastTagParam('adsWillAutoplay', vpaParam);

    if(this.__renderAdWithReponseOverTag){
        
      this.player.ima.setContentWithAdsResponse(null, videoUrl);
    } 
    else{

      this.player.ima.setContentWithAdTag(null, videoUrl, false);
    }

    this.player.ima.requestAds();
};

ValstreamVideoPlayer.prototype.setVideoVastTagParam = function(tagName, tagValue){

    this.player.ima.controller.setSetting(tagName, tagValue);
    
};

//
// Function used to handle click/touch events.
ValstreamVideoPlayer.prototype.handleFirstClickEvent = function(event){
  
    if(this.handledFirstClickEvent){

        return;
    }

    this.handledFirstClickEvent = true;

    if(!this.trackingPlay){

        this.trackingPlay = true;

        this.registerEventListenersOnPlay();
        this.recordSentinelEvent('Play');
    }

    this.registerEventListenersOnPlay();

    this.userAllowedPlayingVideos = true;

    if(this.__soundOn){

        this.handleVolumeToggle(event, 'unmute');
    }

    //for not instream
    if('instream' !== this.videoType){

        this.overlayElement.classList.add('an-vp-int-overlay-slide-up');
    }

    // On first video click when can play ads, show loading screen.
    if(this.isAllowedToPlayAds() && this.isFirstVideo && this.firstPlay){

        this.beginAdTransition();
        this.player.play();
    }

    this.firstPlay = false;

    this.annonceEvent('click');

};

//
// Function used to handle click/touch events.
ValstreamVideoPlayer.prototype.handleClickPlay = function(){

    this.userAllowedPlayingVideos = true;

    if(this.__soundOn){

        this.handleVolumeToggle(event, 'unmute');
    }

    //for not instream
    if('instream' !== this.videoType){

        this.overlayElement.classList.add('an-vp-int-overlay-slide-up');
        // this.overlayElement.classList.remove('an-vp-int-title-active');
    }

    return;
};

//
// Function used to handle click/touch events.
ValstreamVideoPlayer.prototype.handleClickPause = function(){

    this.userAllowedPlayingVideos = false;
};

//
// Function used to handle click/touch events.
ValstreamVideoPlayer.prototype.handleClickEvent = function(event){

    var target          = event.target;
    var parent          = target.parentNode;
    var targetClasses   = Array.from(target.classList);
    var parentClasses   = Array.from(parent.classList);
    var targetIsControl = targetClasses.some(function(className){ return className.includes('control'); });
    var parentIsControl = parentClasses.some(function(className){ return className.includes('control'); });
    var targetIsIMA     = targetClasses.some((className) => className.includes('ima'));
    var type            = event.type;
    var targetIsSkip    = targetClasses.some(function(className){ return className.includes('an-vp-int-skip'); });
    var parentIsSkip    = parentClasses.some(function(className){ return className.includes('an-vp-int-skip'); });

    // if(targetIsControl || parentIsControl || target === this.autoNavStay){

    //     // Stop auto nav on any click event.
    //     this.cancelAutoNav();
    // }

    // 'hover' event for mobile touch controls 
    // Only if not a control action to avoid double click events.
    if(type === 'touchend' && !targetIsControl && !targetIsSkip && !parentIsSkip){

        this.handleOverlayTitleElement();
    }

    // Default elements to hide on any click.
    this.overlayDurationElement.classList.add('an-vp-int-hidden');

    this.logger.debug('Click event.', {
        eventType: type,
        target: target,
        parent: parent,
        targetClasses: targetClasses,
        parentClasses: parentClasses,
        targetIsControl: targetIsControl,
        parentIsControl: parentIsControl,
        targetIsIMA: targetIsIMA,
    });

    this.annonceEvent('click');
};

//
// Start ad skip countdown.
ValstreamVideoPlayer.prototype.adSkipCountdownStart = function(){

    clearInterval(this.adSkipInterval);

    if(this.adSkipNext && this.adSkipCountdown){

        this.logger.debug('Start ad skip.');

        this.adSkipCountdownEneabled   = true;
        var secondsRemaining           = 5;
        this.adSkipCountdown.innerHTML = `${secondsRemaining}`;
        var self                       = this;

        this.adSkipCountdown.classList.add('active');

        // Called every second to change countdown time.
        this.adSkipInterval = window.setInterval(function(){

            // Different bidders/advertisers will have different thresholds for counting an impression.
            // If a user skips the ad, especially right after the countdown finishes, it's possible not all tracking events will be fired.
            // This is ok though.

            // Let countdown continue even when ad is paused depending on config.
            if(self.allowSkipCountdownPause && !self.adSkipCountdownEneabled){

                // Pause countdown.
                return;
            }

            secondsRemaining               -= 1;
            self.adSkipCountdown.innerHTML = `${secondsRemaining}`;

            if(secondsRemaining < 0){

                clearInterval(self.adSkipInterval);
                self.adSkipCountdown.classList.remove('active');
                self.adSkipNext.classList.add('active');
            }
        }, 1000);
    }
}

//
// Pause ad skip countdown.
ValstreamVideoPlayer.prototype.adSkipCountdownPause = function(){

    this.adSkipCountdownEneabled = false;
}

//
// Resume ad skip countdown.
ValstreamVideoPlayer.prototype.adSkipCountdownResume = function(){

    this.adSkipCountdownEneabled = true;
}

//
// Function used to cancel auto navigation.
ValstreamVideoPlayer.prototype.cancelAutoNav = function(){

    if(!this.isAutoplayEnabled() || !this.allowAutoPlaylistNavigation || !this.hasPlaylist){

        return;
    }

    this.logger.debug('Cancel auto nav.');
    clearTimeout(this.autoNavTimeout);
    clearTimeout(this.autoNextTimeout);
    this.autoNav.classList.remove('active');
    this.autoNavNext.classList.remove('transition');
};

//
// Function used to start auto navigation.
ValstreamVideoPlayer.prototype.startAutoNav = function(){

    if(!this.isAutoplayEnabled() || !this.allowAutoPlaylistNavigation || !this.hasPlaylist){

        return;
    }

    this.cancelAutoNav();

    this.logger.debug('Start auto nav.');

    var self = this;

    this.autoNavTimeout = window.setTimeout(function(){

        if(self.autoNav && self.autoNavNext){

            self.autoNav.classList.add('active');
            self.autoNavNext.classList.add('transition');

            self.autoNextTimeout = window.setTimeout(function(){

                self.cancelAutoNav();

                self.isFirstVideo = false;

                self.playlistNext();
                // Restart auto nav after next.
                self.startAutoNav();
            }, self.autoNavTimeInMillisecondsNextVideoTransition);
        }
    }, self.autoNavTimeInMillisecondsNextVideoPrompt);
};

//
// Function used to build player DOM.
ValstreamVideoPlayer.prototype.buildPlayerDom = function(){

    var additionalClasses                = '';
    var additionalClassesTitle1          = ' an-vp-int-hidden ';
    var additionalClassesTitle2          = ' an-vp-int-hidden ';
    var additionalClassesBtnClickThrough = ' an-vp-int-hidden ';
    var additionalClassesDescription     = '';
    var additionalClassesDuration        = ' an-vp-int-hidden ';
    var title                            = '';
    var description                      = '';
    var duration                         = '';
    var loadingScreenStyle               = '';
    var poster                           = '';
    var clickThroughUrl                  = '#';
    var clickThroughText                 = 'Visit';

    if((this.playlistVideoUrls && this.playlistVideoUrls.length > 1) || (this.playlist && this.playlist.length > 1)){

        additionalClasses += ' an-vp-int-playlist ';
    }

    if(this.showTitle){

        additionalClasses       += ' an-vp-int-with-title ';
        additionalClassesTitle2 = additionalClassesTitle2.replace('an-vp-int-hidden', '');
    }

    if((this.playlist && this.playlist.length > 0)){

        title            = this.playlist[0]['title'] || '';
        description      = this.playlist[0]['description'] || '';
        duration         = this.playlist[0]['length'] || '';
        poster           = this.playlist[0]['thumbnailLink'] || '';
        clickThroughText = (this.playlist[0]['clickThroughText']) ? this.playlist[0]['clickThroughText'] : clickThroughText;
        clickThroughUrl  = (this.playlist[0]['clickThroughUrl']) ? this.playlist[0]['clickThroughUrl'] : clickThroughUrl;

        poster.trim();
        poster.replace('"', '\"');
        poster.replace("'", "\'");
        title.replace('"', '&quot;');
        description.replace('"', '&quot;');
        duration.replace('"', '&quot;');

        if(poster){

            loadingScreenStyle = `background-image: url('${poster}');`;
        }
    }

    if(this.showOverlays && title){

        additionalClasses       += ' an-vp-int-with-overlays ';
        additionalClassesTitle1 = additionalClassesTitle1.replace('an-vp-int-hidden', '');

        if(this.showClickThroughButton && clickThroughText){

            additionalClassesBtnClickThrough = additionalClassesBtnClickThrough.replace('an-vp-int-hidden', '');
        }
    }

    if(this.showOverlays && duration){

        additionalClassesDuration = additionalClassesDuration.replace('an-vp-int-hidden', '');
    }

    var additionalVideoAttributes = '';

    if(!this.__soundOn){

        additionalVideoAttributes = ' muted';
    }

    var idDetails = '';

    if(this.allowAutoplay){

        idDetails = `id="${this.elementId}-video"`;
    }

    var additionalClassesMuteButton = (this.__useLargeSoundToggleButton) ? '' : ' is-hidden ';
    additionalClassesMuteButton     += (this.__soundOn) ? ' an-vp-unmuted ' : ' an-vp-muted ';

    return `
        <div class='an-vp-int ${additionalClasses}'>
            <div class='an-vp-int-c-video'>
                <div class='an-vp-int-c-video-inner'>
                    <div class="an-vp-int-overlays an-vp-int-overlays-top">
                        <a class="an-vp-int-title an-vp-int-title-overlay ${additionalClassesTitle1}" href="${clickThroughUrl}">${title}</a>
                        <a class="an-vp-int-overlay-btn-click-through ${additionalClassesBtnClickThrough}" href="${clickThroughUrl}"><span>${clickThroughText}</span></a>
                    </div>
                    <div class="an-vp-int-loading-screen" style="${loadingScreenStyle}">
                        <div class="an-vp-int-loading-screen-title" title="Now Playing">Now Playing</div>
                    <!-- <h2 class="an-vp-int-loading-screen-subtitle" title="${title}">${title}</h2> -->
                    </div>
                    <button class="an-vp-btn-mute ${additionalClassesMuteButton}"></button>
                    <div class='an-vp-int-modal-close'></div>
                    <div class='an-vp-int-auto-nav-container'>
                        <div class='an-vp-int-auto-nav an-vp-int-stay'>WATCH</div>
                        <div class='an-vp-int-auto-nav an-vp-int-next'>NEXT</div>
                    </div>
                    <video
                        ${idDetails}
                        class='an-vp-int-video video-js vjs-default-skin vjs-big-play-centered'
                        controls
                        playsinline
                        ${additionalVideoAttributes}
                    >
                    </video>
                    <div class='an-vp-int-skip-btn'>
                        <div class='an-vp-int-skip-text'>
                            <span>Skip Ad</span>
                        </div>
                        <div class='an-vp-int-skip-counter'>5</div>
                    </div>
                    <div class="an-vp-int-overlays an-vp-int-overlays-bottom">
                        <span class="an-vp-int-duration an-vp-int-duration-overlay ${additionalClassesDuration}">${duration}</span>
                    </div>
                </div>
            </div>
            <div class="an-vp-int-details">
                <div class="an-vp-int-title ${additionalClassesTitle2}">${title}</div>
<!--                <div class="an-vp-int-description ${additionalClassesDescription}">${description}</div>-->
            </div>
        </div>
    `;
};

//
// Function used to observe the player DOM.
ValstreamVideoPlayer.prototype.observePlayer = function(){ // TODO: Switch to waypoints?

    var self = this;

    const handleIntersect = function(entries){

        entries.forEach(function(entry){

            // If video has been in the viewport, we can make it sticky when not intersecting.
            if(entry.isIntersecting){

                self.isVisible = true;

                // Start playing the video on the first viewport intersection.
                if(!self.intersectedViewport){

                    self.intersectedViewport = true;

                    if(self.isAutoplayEnabled()){

                        self.player.play();
                        self.startAutoNav();

                        if(!self.trackingPlay){

                            self.trackingPlay = true;

                            self.recordSentinelEvent('Play');
                        }
                    }
                }
                else if(self.isEnabledAds() && self.intersectedViewport && self.adPlaying && self.isAutoplayEnabled() && self.allowAutoplayWhenInView){

                    self.player.ima.resumeAd();
                }
                else if(self.intersectedViewport && self.isAutoplayEnabled() && self.allowAutoplayWhenInView){

                    self.player.play();
                }
            }
            else if((self.__externalFloatControl && self.stickyClosed) || !self.__externalFloatControl){

                // Need this condition for when not player is not intersecting the window.
                self.isVisible = false;

                if(self.isAutoplayEnabled() && self.allowAutoplayWhenInView){

                    self.pause();
                }
            }
        });
    };

    var observer = new IntersectionObserver(handleIntersect, {
        root: null,
        rootMargin: '0px',
        threshold: 0.45,
    });

    observer.observe(this.videoContainer);
};

//
// Record events with bidding manager.
ValstreamVideoPlayer.prototype.recordEvent = function(type, message = null, value = null, unique = true){

    this.__dispatchEvent('AdsNinjaVideoPlayerLoggableEvent', type, message, value, unique);
};

//
// Annonce events to bidding manager.
ValstreamVideoPlayer.prototype.annonceEvent = function(type){
    
    this.__dispatchEvent('AdsNinjaVideoPlayerEvent', type, null, null, false);
}

// Record Sentinel events with bidding manager.
ValstreamVideoPlayer.prototype.recordSentinelEvent = function(type, message = null, value = null, unique = true){

    this.__dispatchEvent('AdsNinjaVideoPlayerSentinelEvent', type, message, value, unique);
};

//
// Record events with bidding manager.
ValstreamVideoPlayer.prototype.__dispatchEvent = function(type, detailType, message = null, value = null, unique = true){

    if(unique && this.eventLog.hasOwnProperty(detailType)){

        return;
    }

    if(!this.eventLog.hasOwnProperty(detailType)){

        this.eventLog[detailType] = 0;
    }

    this.eventLog[detailType]++;

    var data = {
        isAutoplay: this.allowAutoplay,
        videoUrl: this.getCurrentPlaylistItemUrl(),
        isAdPlaying: this.adPlaying,
    };

    var event = new CustomEvent(type, {
        bubbles: false,
        detail: {
            elementId: this.elementId,
            type: detailType,
            message: message,
            value: value,
            data: data,
        },
    });

    window.dispatchEvent(event);
};

//
// Resume ad skip countdown.
ValstreamVideoPlayer.prototype.logToGoogleAnalytics = function(hitType, eventCategory, eventAction, eventLabel, eventValue){

    if(!this.googleAnalytics){

        return;
    }

    var gaData = {
        hitType: hitType,
        eventCategory: eventCategory,
        eventAction: eventAction,
    };

    if(eventLabel){

        gaData['eventLabel'] = eventLabel;
    }

    if(eventValue){

        gaData['eventValue'] = eventValue;
    }

    this.googleAnalytics('send', gaData);
}

//
// Sets the title for video player.
ValstreamVideoPlayer.prototype.setTitle = function(title){

    title.replace('"', '&quot;');

    this.titleElement.innerHTML        = title;
    this.overlayTitleElement.innerHTML = title;
};

//
// Sets the title for video player.
ValstreamVideoPlayer.prototype.setClickThroughUrlAndText = function(text, url){
    
    text.replace('"', '&quot;');

    this.overlayTitleElement.href                   = url;
    this.overlayClickThroughButtonElement.href      = url;
    this.overlayClickThroughButtonElement.innerHTML = `<span>${text}</span>`; // FE requires a span.
};

//
// Sets the description for video player.
ValstreamVideoPlayer.prototype.setDescription = function(description){

    description.replace('"', '&quot;');

    // this.descriptionElement.innerHTML = description;
};

//
// Sets the poster for video player.
ValstreamVideoPlayer.prototype.setPoster = function(url){

    var style = '';

    if(url){

        style = `background-image: url('${url}');`;
    }

    this.loadingScreenElement.style = style;
};

//
// Sets video details.
ValstreamVideoPlayer.prototype.setVideoDetails = function(playlistItem){

    this.setTitle(playlistItem['title']);
    // this.setDescription(playlistItem['description'] || '');

    this.setClickThroughUrlAndText(playlistItem['clickThroughText'], playlistItem['clickThroughUrl']);
    this.setPoster(playlistItem['poster']);
};

/**
 * Reset the video player.
 * 
 * @param {Object} playlist
 * @param {string} identifier
 */
ValstreamVideoPlayer.prototype.reset = function(playlist, identifier = null){

    this.userAllowedPlayingVideos = false;

    // Force pause ad/content.
    this.__pauseAd();
    this.killAd();
    this.__stopAd();
    this.handleAdDone();
    this.pause();
    this.changePlaylist(playlist);

    // Reset tracking events.
    this.eventLog                                           = {};
    this.trackingVideoProgressStarted                       = false;
    this.trackingVideoProgressStartedAfterPrerollAds        = false;
    this.trackingVideoProgressThresholdPassedFirst          = false;
    this.trackingVideoProgressThresholdPassedSecond         = false;
    this.trackingVideoProgressThresholdPassedThird          = false;
    this.trackingVideoProgressThresholdPassedForth          = false;
    this.trackingVideoProgressThresholdPassedMidrollAuction = false;
    this.trackingVideoProgressThresholdPassedMidrollRequest = false;
    this.trackingVideoProgressSeeked                        = false;
    this.trackingVideoProgressEnded                         = false;
    this.trackingPlay                                       = false;

    if(identifier){
    
        this.changeTrackingId(identifier);
    }
};

/**
 * Set the playlist index.
 * 
 * @param {number} index
 */
ValstreamVideoPlayer.prototype.setPlaylistIndex = function(index){

    this.player.playlist.setCurrentIndex(index);
};

/**
 * Set the playlist.
 * 
 * @param {Object} playlist
 */
ValstreamVideoPlayer.prototype.setTime = function(time){
    
    if(!time || typeof time !== 'number'){
    
        throw new Error('Time must be a number.');
    }

    if(!this.playlist || Array.isArray(this.playlist) && this.playlist.length === 0){
    
        return false;
    }

    this.player.currentTime(time);
};

/**
 * Change the tracking id.
 * 
 * @param {string} value
 */
ValstreamVideoPlayer.prototype.changeTrackingId = function(value){

    if(!value || typeof value !== 'string'){
    
        throw new Error('Tracking id must be a string.');
    }
    
    window.adsNinjaHeaderBiddingManager.overwirteEventTrackingDictionaryItem(this.elementId, value);
};

/**
 * Advance to the next playlist item.
 * 
 * @param {Object} playlist
 */
ValstreamVideoPlayer.prototype.changePlaylist = function(playlist){
    
    if(!playlist || Array.isArray(playlist) && playlist.length === 0){
    
        return false;
    }

    var newPlaylist = [];

    for(var p in playlist){

        var playlistItem    = playlist[p];
        var newplaylistItem = {
            controls: true,
            sources: [{
                src: playlistItem['url'],
                type: playlistItem['mimeType'] || 'video/mp4',
            }],
            title: playlistItem['title'] || '',
            description: playlistItem['description'] || '',
            duration: playlistItem['length'] || '',
            clickThroughText: (playlistItem['clickThroughText']) ? playlistItem['clickThroughText'] : 'Visit',
            clickThroughUrl: (playlistItem['clickThroughUrl']) ? playlistItem['clickThroughUrl'] : '#',
            url: playlistItem['url']
        };

        // Add posters when needed.
        if(playlistItem.hasOwnProperty('thumbnailLink') && playlistItem['thumbnailLink']){

            newplaylistItem['poster'] = playlistItem['thumbnailLink'];
        }

        // TODO: No need to add text tracks if there are none.
        if(playlistItem.hasOwnProperty('textTracks') && playlistItem['textTracks'].length > 0){

            this.hasTextTracks = true;

            for(var tt in playlistItem['textTracks']){

                var textTrack = playlistItem['textTracks'][tt];

                // Validate textTrack.
                if(this.isInvalidTextTrack(textTrack)){

                    this.logger.warning(`Invalid text track.`, textTrack);
                    continue;
                }

                textTrack['src']     = textTrack['url'];
                textTrack['srcLang'] = textTrack['language'];

                if(!newplaylistItem.hasOwnProperty('textTracks')){

                    newplaylistItem['textTracks'] = [];
                }

                newplaylistItem['textTracks'].push(textTrack);
            }
        }

        newPlaylist.push(newplaylistItem);
    }

    if(newPlaylist.length === 0){

        return false;
    }

    this.player.playlist(newPlaylist);

    this.currentPlaylistItem = newPlaylist[0];
    
    // Force reset the player.
    this.setVideoDetails(this.currentPlaylistItem);
    this.player.src({ src: this.currentPlaylistItem['sources'][0]['src'], type: this.currentPlaylistItem['sources'][0]['type'] });
    this.player.poster(this.currentPlaylistItem['poster'] || '');
    this.player.currentTime(0);
    // this.player.load();

    this.isFirstVideo = true;
    this.firstPlay    = true;
    this.playlist     = newPlaylist;
    this.hasPlaylist  = true;

    return true;
};

/**
 * Advance to the next playlist item.
 * 
 * @param {boolean} resumePlayback
 */
ValstreamVideoPlayer.prototype.next = function(resumePlayback = true){

    var playlistItem         = this.player.playlist.next();
    this.currentPlaylistItem = playlistItem;

    if(this.changingVideoDetails && playlistItem){

        this.setVideoDetails(playlistItem);
    }

    if(resumePlayback){

        this.isFirstVideo = false;

        if(this.player.paused() && !this.adPlaying){

            this.player.play();
        }
    }
};

/**
 * @deprecated
 * Advance to the next playlist item.
 * 
 * @param {boolean} resumePlayback
 */
ValstreamVideoPlayer.prototype.playlistNext = function(resumePlayback = true){

    this.next(resumePlayback);
};

/**
 * Advance to the previous playlist item.
 */
ValstreamVideoPlayer.prototype.previous = function(){

    var playlistItem         = this.player.playlist.previous();
    this.currentPlaylistItem = playlistItem;
    this.isFirstVideo        = false;

    if(this.changingVideoDetails && playlistItem){

        this.setVideoDetails(playlistItem);
    }

    if(this.player.paused() && !this.adPlaying){

        this.player.play();
    }
};

/**
 * @deprecated
 * Advance to the previous playlist item.
 */
ValstreamVideoPlayer.prototype.playlistPrevious = function(){

    this.previous();
};

//
// Go back to the previous playlist item.
ValstreamVideoPlayer.prototype.getCurrentPlaylistItemUrl = function(){

    return (this.currentPlaylistItem && this.currentPlaylistItem.hasOwnProperty('url')) ? this.currentPlaylistItem['url'] : '';
};

//
// Handles floating close button click.
ValstreamVideoPlayer.prototype.handleAdDone = function(allowAutoNavigation = true){

    // Reset ad skip button.
    clearInterval(this.adSkipInterval);
    this.adSkipCountdown.classList.remove('active');
    this.adSkipNext.classList.remove('active');

    this.adStarting                 = false;
    this.adPlaying                  = false;
    this.midRollUpcoming            = false;
    this.adFinishing                = true;
    this.hasPreparedForNextPlayback = false;
    this.firstPlay                  = false;

    this.videoPlayerElement.classList.remove('an-vp-int-ad-playing');

    this.endAdTransition();

    if(allowAutoNavigation){

        this.startAutoNav();
    }
    
    this.notifyAdIsComplete();
};

//
// Notify ad is ready to play.
ValstreamVideoPlayer.prototype.notifyAdIsReadyToPlay = function(){

    if(this.biddingManager && !this.hasPlaylist){

        return this.biddingManager.handleAdIsReadyToPlay(this.elementId);
    }

    return true;
};

//
// Notify ad is complete.
ValstreamVideoPlayer.prototype.notifyAdIsComplete = function(){

    if(this.biddingManager && !this.hasPlaylist){

        return this.biddingManager.handleAdIsComplete(this.elementId);
    }

    return true;
};

//
// Handles floating close button click.
ValstreamVideoPlayer.prototype.handleFloatingDisallowed = function(refloatAllowed = false){

    this.videoContainerInnerHeight              = 'inherit';
    this.videoContainerInnerWidth               = 'inherit';
    this.videoContainerInner.style.width        = 'inherit';
    this.videoContainer.parentNode.style.height = 'inherit';
    this.videoContainer.parentNode.style.width  = 'inherit';
    this.stickyClosed                           = true;

    if(this.isAutoplayEnabled() && !this.allowAutoPlaylistNavigation && this.isEnabledAds() && this.inAdBreak()){

        this.player.ima.pauseAd();
    }
    else if(!this.hasPlaylist && this.isAutoplayEnabled() && !this.allowAutoPlaylistNavigation && this.isEnabledAds() && refloatAllowed){

        // Prepare next if allowed.
        this.handleAdSkip(this.delayAfterAdClosedInMilliseconds);
    }
    else if(!this.hasPlaylist && this.isAutoplayEnabled() && !this.allowAutoPlaylistNavigation && this.isEnabledAds() && !refloatAllowed){

        // No more ads allowed.
        this.__stopAd();
        this.handleAdDone();
    }
    else if(this.hasPlaylist && this.isAutoplayEnabled() && !this.allowAutoPlaylistNavigation){

        this.player.muted(true);
        this.player.pause();
    }

    this.cancelAutoNav();

    // TODO: Could also be isVisibleOrFloating or better yet isInView to help distinguish that tab changes don't effect this value.
    this.isVisible = false;

    // this.recordEvent('playerClose');
};

//
// Stop playing an ad.
ValstreamVideoPlayer.prototype.__stopAd = function(refloatAllowed = false){

    if(this.googleImaAdManager && typeof this.googleImaAdManager === 'object' && typeof this.googleImaAdManager.stop === 'function'){

        // Whether or not an ad is skippable is determined by the VAST XML that is returned.
        // Even though all our of settings are configured to set ads as skippable after 5 seconds, not all bidders adhere to this.
        // Many will still return VAST creatives without a skip option. We use AdManager.stop() instead to force the skipping feature.
        // The function AdManager.skip() only works if a skip option exists in the VAST XML.
        this.googleImaAdManager.stop();
    }
};

//
// Pause playing an ad.
ValstreamVideoPlayer.prototype.__pauseAd = function(){

    if(this.googleImaAdManager && typeof this.googleImaAdManager === 'object' && typeof this.googleImaAdManager.pause === 'function'){

        this.googleImaAdManager.pause();
    }
};

//
// Handles floating disengaged.
ValstreamVideoPlayer.prototype.handleFloatingDisengaged = function(height, width){

    this.videoContainerInnerHeight       = height;
    this.videoContainerInnerWidth        = width;
    this.videoContainerInner.style.width = `${this.videoContainerInnerWidth}`;
};

//
// Handles floating engaged.
ValstreamVideoPlayer.prototype.handleFloatingEngaged = function(height, width){

    this.videoContainerInnerHeight       = height;
    this.videoContainerInnerWidth        = width;
    this.videoContainerInner.style.width = `${this.videoContainerInnerWidth}`;
};

//
// Request the next pre-roll ad.
ValstreamVideoPlayer.prototype.tryRenderingVideoAdInQueue = function(){

    if(this.videoAdQueue.length === 0){

        return false;
    }

    var videoUrl = this.videoAdQueue.shift();

    if(!videoUrl){

        return false;
    }

    this.renderAd(videoUrl, this.currentPlacement, true);

    return true;
};

//
// Handle ad skip.
ValstreamVideoPlayer.prototype.handleAdSkip = function(nextPlayBackDelay = 0){

    this.__stopAd();
    this.handleAdDone();

    // Render next pre-roll.
    var hasRenderedVideoAdInQueue = false;

    if(this.hasPlaylist && this.prerollCount < this.maxPrerollAdCount){

        this.adFinishing          = false;
        hasRenderedVideoAdInQueue = this.tryRenderingVideoAdInQueue();

        if(!hasRenderedVideoAdInQueue){

            this.requestNextPrerollAd(true);
        }
    }
    else if(!this.hasPlaylist){

        this.prepareForNextPlayback(nextPlayBackDelay);
    }

    // stop any auto title hide when loading video from ad skip 
    this.handleOverlayTitleElement(true);

    // this.recordEvent('skipAd');
}

//
// Request the next pre-roll ad.
ValstreamVideoPlayer.prototype.requestNextPrerollAd = function(ignoreInAdBreak = false){

    this.logger.debug('Requesting next pre-roll ad.', {
        elementId: this.elementId,
    });

    // Will not trigger new auction.
    // if(!this.isPrimeGeo()){

    //     // Start next auction.
    //     this.logger.debug('Pre-roll request denied. ', {
    //         elementId: this.elementId,
    //         placement: placement,
    //         geo: this.getGeo(),
    //         totalAdRenderAttempts: this.__totalAdRenderAttempts,
    //     });

    //     return;
    // }

    var videoUrl = this.biddingManager.requestNextPrerollAd(this.elementId);

    if(!videoUrl){

        return;
    }

    this.logger.debug('Received next pre-roll ad.', {
        elementId: this.elementId,
        videoUrl: videoUrl,
    });

    this.renderAd(videoUrl, 'preroll', ignoreInAdBreak);
};

//
// Request the next pre-roll ad.
// Can ignore the result to augment the bid pool.
ValstreamVideoPlayer.prototype.requestNextAuction = function(placement, ignoreResult = false){

    if(!this.isEnabledAds()){

        return;
    }

    // Start next auction.
    this.logger.debug('Requesting next auction.', {
        elementId: this.elementId,
        placement: placement,
    });

    if(ignoreResult || (!this.isPrimeGeo() && (ignoreResult || this.__totalAdRenderAttempts >= 1))){

        this.logger.debug('Auction request denied. ', {
            elementId: this.elementId,
            placement: placement,
            isSeed: ignoreResult,
            geo: this.getGeo(),
            totalAdRenderAttempts: this.__totalAdRenderAttempts,
        });

        return;
    }

    var self = this;

    this.biddingManager.requestNextAuctionVideo(this.elementId, placement, ignoreResult, function(videoUrl, disableAds = false){

        self.handleAuctionDone(videoUrl, placement, ignoreResult, disableAds);
    });
};

//
// Request the next pre-roll ad.
ValstreamVideoPlayer.prototype.handleAuctionDone = function(videoUrl, placement, ignoreResult, disableAds){

    if(disableAds){

        this.disableAds();
        this.handleAdDone();
        return;
    }

    // Inflate bid pool for subcontinent auctions.
    if(ignoreResult){

        return;
    }

    if('preroll' === placement){

        this.renderAd(videoUrl, placement);
    }
    else{

        this.addAdToQueue(videoUrl, placement);
    }
};


//
// Enable ads for video player.
ValstreamVideoPlayer.prototype.enableAds = function(){

    this.__isEnabledAds = true;
};

//
// Kill ads for video player.
ValstreamVideoPlayer.prototype.killAd = function(){

    if(this.isEnabledAds() && this.inAdBreak()){

        this.player.ads.endLinearAdMode();
    }
    else if(this.isEnabledAds() && this.player.ads.isWaitingForAdBreak() && !this.player.ads.isContentResuming()){

        this.player.ads.skipLinearAdMode();
    }
};

//
// Disable ads for video player.
ValstreamVideoPlayer.prototype.disableAds = function(){

    this.killAd();

    this.__isEnabledAds = false;
};

//
// Request the next pre-roll ad.
ValstreamVideoPlayer.prototype.isEnabledAds = function(){

    return (this.canSupportPlayingAds() && this.isAllowedToPlayAds() && this.__isEnabledAds);
};

//
// Request the next pre-roll ad.
ValstreamVideoPlayer.prototype.isAllowedToPlayAds = function(){

    return this.__allowAds;
};

//
// Request the next pre-roll ad.
ValstreamVideoPlayer.prototype.canSupportPlayingAds = function(){

    return (this.googleLibrary && typeof this.googleLibrary.ima !== 'undefined' && this.biddingManager && typeof this.biddingManager !== 'undefined');
};

//
// Callback for mark bids as used.
ValstreamVideoPlayer.prototype.markBidAsUsedCallback = function(addSkipButton){

    // Only show ad skip for companion & instream
    if(addSkipButton && this.hasPlaylist){

        this.adSkipCountdownStart();
    }
};

//
// Ad progress.
ValstreamVideoPlayer.prototype.adProgressCallback = function(adEvent){

    if(this.adPlaying){

        this.adStarting = false;
    }

    var adData      = adEvent.getAdData(); 
    var currentTime = adData.currentTime;
    var duration    = adData.duration;

    if(0 === currentTime){

        return;
    }

    // Record Ad Impression after 1 second of playback
    if(!this.recordedAdImpression && currentTime >= 1){
        clearTimeout(this.videoPlayFailsafe);
        this.recordedAdImpression = true;

        if(this.currentCreativeIds.length > 0){

            this.biddingManager.recordAdImpression(this.currentCreativeIds, this.elementId);
        }
    }

    if(this.engagementHelper && typeof this.engagementHelper === 'object'){

        if(typeof this.engagementHelper.startTracking === 'function'){

          this.engagementHelper.startTracking();
        }

        if(typeof this.engagementHelper.checkEngagement === 'function'){

          this.engagementHelper.checkEngagement();
        }
    }

    if(this.__forceAdSkip && currentTime < duration && currentTime >= this.__forceAdSkipTimeoutInSeconds){

        this.logger.debug('Ad progress event. Ad is too long, force skipping.', {
          currentTime: currentTime,
          duration: duration,
        }, false);

        // Skip current ad.
        this.handleAdSkip();
    }
}


//
// Callback when an ad is loaded into IMA
ValstreamVideoPlayer.prototype.adLoadedCallback = function(adEvent){
    var adData = adEvent.ad?.data;
    if (adData) {
      var creativeIds = [...adData.adWrapperIds, ...adData.adWrapperCreativeIds];
      this.currentCreativeIds = creativeIds;
      this.currentAdWrapperSystems = adData.adWrapperSystems?.filter(x => x) || [];
    }
};

//
// Callback for user skipping an ad action.
ValstreamVideoPlayer.prototype.adStartCallback = function(adEvent){

    this.logger.debug('Ad start event.', {
        adEvent: adEvent,
    }, false);

    this.annonceEvent('play');

    if(!this.trackingPlay){

        this.trackingPlay = true;

        this.registerEventListenersOnPlay();

        this.recordSentinelEvent('Play');
    }

    this.adStarting = true;
    this.firstPlay  = false;
    this.recordedAdImpression = false;

    this.videoPlayerElement.classList.add('an-vp-int-ad-playing');

    // Handle issue with mute button causing player video and ad to be out of sync.
    if(this.player.muted()){

        this.mute();
    }

    this.cancelAutoNav();

    var notificationResult = this.notifyAdIsReadyToPlay();

    this.adPlaying = true;
    var ad         = adEvent.getAd();

    if(ad){

        var creativeIds = [...ad.getWrapperAdIds(), ...ad.getWrapperCreativeIds()];

        if(['TopSpeed', 'TheGamer'].indexOf(window.adsNinjaHeaderBiddingManager.getBrandName()) !== -1){
          this.biddingManager.markBidAsUsedByAdId(this.elementId, creativeIds, this.markBidAsUsedCallback.bind(this));
        } else {
          this.biddingManager.markBidAsUsed(this.elementId, creativeIds, this.markBidAsUsedCallback.bind(this));
        }

        if(creativeIds && creativeIds.length > 0){

            this.logger.debug('Marked bids as used.', {
                adEvent: adEvent,
            }, false);
        }
        else{

            // Unable to retrieve creative IDs needed to mark a bid as used.
            // Every highest bid will be marked as used to avoid re-using bids.
            this.logger.warn('Unable to access IMA ad info. Marked all highest bids as used.', {
                adEvent: adEvent,
            }, false);

            // this.recordEvent('interactiveMediaAdsError', 'Unable to access IMA ad info.', {
            //     ad: ad,
            // });
        }
    }

    // Reset retries.
    this.adErrorRetries = 0;

    // Run a second auction for more bids on first fill.
    if(this.hasPlaylist && this.prerollCount < this.maxPrerollAdCount && !this.usedSecondAuction){

        this.usedSecondAuction = true;

        // Start next auction.
        this.requestNextAuction('preroll');
    }
    else if(!this.hasPlaylist){

        this.requestNextAuction('preroll', true);
    }

    if(!notificationResult){

        this.pause();
    }

    this.handleFirstClickEvent();
};

//
// Callback for ad completed playing.
ValstreamVideoPlayer.prototype.adCompleteCallback = function(adEvent){

    this.logger.debug('Ad complete event.', {
        adEvent: adEvent,
    }, false);

    this.handleAdDone();

    var hasRenderedVideoAdInQueue = false;

    if(this.hasPlaylist && this.prerollCount < this.maxPrerollAdCount){

        this.adFinishing          = false;
        hasRenderedVideoAdInQueue = this.tryRenderingVideoAdInQueue();

        if(!hasRenderedVideoAdInQueue){

            this.requestNextPrerollAd(true);
        }
    }
    else if(!this.hasPlaylist){

        this.prepareForNextPlayback();
    }

    this.handleFirstClickEvent();
};

//
// Callback for user skipping an ad action.
ValstreamVideoPlayer.prototype.adSkipCallback = function(adEvent){

    this.logger.debug('Ad skipped event.', {
        adEvent: adEvent,
    }, false);

    this.handleAdDone();

    var hasRenderedVideoAdInQueue = false;

    if(this.hasPlaylist && this.prerollCount < this.maxPrerollAdCount){

        this.adFinishing          = false;
        hasRenderedVideoAdInQueue = this.tryRenderingVideoAdInQueue();

        if(!hasRenderedVideoAdInQueue){

            this.requestNextPrerollAd(true);
        }
    }
    else if(!this.hasPlaylist){

        this.prepareForNextPlayback();
    }

    this.handleFirstClickEvent();
};

//
// Callback for user skipping an ad action.
ValstreamVideoPlayer.prototype.adPauseCallback = function(adEvent){

    this.logger.debug('Ad paused event.', {
        adEvent: adEvent,
    }, false);

    this.adSkipCountdownPause();

    if(this.engagementHelper && typeof this.engagementHelper === 'object' && typeof this.engagementHelper.stopTracking === 'function'){

        this.engagementHelper.stopTracking();
    }

    this.handleFirstClickEvent();
};

//
// Callback for user skipping an ad action.
ValstreamVideoPlayer.prototype.adResumeCallback = function(adEvent){

    this.logger.debug('Ad resume event.', {
        adEvent: adEvent,
    }, false);

    this.annonceEvent('play');

    this.adSkipCountdownResume();
};

//
// Callback for user click an ad action.
ValstreamVideoPlayer.prototype.clickCallback = function(adEvent){

    this.logger.debug('Ad click event.', {
        adEvent: adEvent,
    }, false);

    this.handleFirstClickEvent();

    this.annonceEvent('click');
};

//
// Callback for user closing an ad action.
// This doesn't seem to be used much if at all.
ValstreamVideoPlayer.prototype.userCloseCallback = function(adEvent){

    this.logger.debug('Ad user closed event.', {
        adEvent: adEvent,
    }, false);

    this.handleAdDone();

    var hasRenderedVideoAdInQueue = false;

    if(this.hasPlaylist && this.prerollCount < this.maxPrerollAdCount){

        this.adFinishing          = false;
        hasRenderedVideoAdInQueue = this.tryRenderingVideoAdInQueue();

        if(!hasRenderedVideoAdInQueue){

            this.requestNextPrerollAd(true);
        }
    }
    else if(!this.hasPlaylist){

        this.prepareForNextPlayback();
    }
};

//
// Handles adsManager callback.
ValstreamVideoPlayer.prototype.adsManagerLoadedCallback = function(response){

    this.logger.debug('Ads manager event.');

    if (!response || typeof response !== 'object' || !response.hasOwnProperty('adsManager')) {

        return;
    }

    this.googleImaAdManager = response.adsManager;

    if (!this.googleImaAdManager) {

        this.logger.error('Unable to retrieve Google IMA ad manager from event.');
        return;
    }

    this.googleImaAdManager.configureAdsManager(this.player, {
        enablePreloading: true,
        loadVideoTimeout: this.prerollTimeoutInMilliseconds,
    });

    var self       = this;
    var handleTime = self.eventHelper.throttle(function(event){

        self.adProgressCallback(event);
    }, 500);

    // Attach IMA event listeners.
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.COMPLETE, this.adCompleteCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.LOADED, this.adLoadedCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.STARTED, this.adStartCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.SKIPPED, this.adSkipCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.VIDEO_CLICKED, this.clickCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.CLICK, this.clickCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.VIDEO_ICON_CLICKED, this.clickCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.INTERACTION, this.clickCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.PAUSED, this.adPauseCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.RESUMED, this.adResumeCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.USER_CLOSE, this.userCloseCallback.bind(this));
    this.player.ima.addEventListener(this.googleLibrary.ima.AdEvent.Type.AD_PROGRESS, handleTime);

    if(!this.adMuteElement){

        // To avoid redefining.
        this.adMuteElement              = this.videoContainer.querySelector('.ima-mute-div');
        this.adVolumeSliderLevelElement = this.videoContainer.querySelector('.ima-slider-level-div');
    
        if(this.player.muted()){

            this.mute();
        }
        else{

            this.__setVolume(this.player.volume());
        }

        this.__registerAdEventListeners();
    }
}

//
// Handles adsLoader callback.
ValstreamVideoPlayer.prototype.adsLoaderLoadedCallback = function(response){

    this.logger.debug('Ads loader event.');
    this.processAdsLoaderQueue();
}

//
// Process queue.
ValstreamVideoPlayer.prototype.processAdsLoaderQueue = function(){

    // Execute all closures currently in the queue.
    while(this.__adsLoaderQueue.length > 0){

        var closure = this.__adsLoaderQueue.shift();

        try{

            closure();
        }
        catch(error){

            this.logger.error('Error encountered while processing queue.', {
                message: error.message,
                closure: closure,
            });
        }
    }

    if(this.__firstAdsLoaderQueueProcessing){

        var self = this;

        // Override methods to call our handler.
        // This way closures pushed to the queue will be executed immediately from this point on.
        this.__adsLoaderQueue.push = function(){

            Array.prototype.push.apply(this, arguments);
            self.processAdsLoaderQueue();
        };

        this.__adsLoaderQueue.unshift = function(){

            Array.prototype.unshift.apply(this, arguments);
            self.processAdsLoaderQueue();
        };

        this.__firstAdsLoaderQueueProcessing = false;
    }
};

//
// Handles adsManager callback.
ValstreamVideoPlayer.prototype.initializeAds = function(){

    if(!this.isAllowedToPlayAds() || this.adDisplayInitialized || !this.player.hasOwnProperty('ima') || typeof this.player.ima.initializeAdDisplayContainer !== 'function'){

        return;
    }

    this.adDisplayInitialized = true;

    this.player.ima.initializeAdDisplayContainer();
}

//
// Handles adsManager callback.
ValstreamVideoPlayer.prototype.__createDefaultAdSchedule = function(){
    
    return {
        preRolls: {
            amount: this.DEFAULT_MAX_AD_PREROLL_COUNT,
        },
        midRolls: {
            amount: 1,
            intervalMin: 45,
            intervalMax: 300,  
            intervalMultiplier: 2,
        },
        postRolls: {
            amount: 0,
        },
    };
}

//
// Sets ad schedule.
ValstreamVideoPlayer.prototype.setAdSchedule = function(adSchedule){
    
    this.__adSchedule                = (this.isAllowedToPlayAds() && adSchedule && typeof adSchedule === 'object') ? adSchedule || this.__createDefaultAdSchedule() : null; 
    this.maxPrerollAdCount           = (this.__adSchedule && this.__adSchedule.hasOwnProperty('preRolls') && this.__adSchedule.preRolls.hasOwnProperty('amount')) ? this.__adSchedule.preRolls.amount : this.DEFAULT_MAX_AD_PREROLL_COUNT;
    this.midrollThresholdRequest     = 5;
    this.midrollThresholdAuction     = (this.__adSchedule && this.__adSchedule.hasOwnProperty('midRolls') && this.__adSchedule.midRolls.hasOwnProperty('intervalMin')) ? this.__adSchedule.midRolls.intervalMin - this.midrollThresholdRequest : 40;
    this.midrollIntervalMax          = (this.__adSchedule && this.__adSchedule.hasOwnProperty('midRolls') && this.__adSchedule.midRolls.hasOwnProperty('intervalMax')) ? this.__adSchedule.midRolls.intervalMax - this.midrollThresholdRequest : 300 - this.midrollThresholdRequest;
    this.midrollIntervalMultiplier   = (this.__adSchedule && this.__adSchedule.hasOwnProperty('midRolls') && this.__adSchedule.midRolls.hasOwnProperty('intervalMultiplier')) ? this.__adSchedule.midRolls.intervalMultiplier : 2;
    this.baseMidrollThresholdRequest = this.midrollThresholdRequest;
    this.baseMidrollThresholdAuction = this.midrollThresholdAuction;
    this.nextMidrollThresholdRequest = this.baseMidrollThresholdAuction + this.baseMidrollThresholdRequest;
    this.nextMidrollThresholdAuction = this.baseMidrollThresholdAuction;
}

//
// callback for preparing for next playback.
ValstreamVideoPlayer.prototype.prepareForNextPlaybackCallback = function(){

    this.cancelAutoNav(); // Precaution.

    if(!this.isEnabledAds() || (this.isEnabledAds() && !this.hasPlaylist && !this.isAutoplayEnabled())){

        this.hasPreparedForNextPlayback = false;

        return;
    }

    this.hasPreparedForNextPlayback = true;

    // TODO: Maybe check if you can play ads here with by checking existence of "player.ima" and "player.ads".

    // Reset properties.
    this.adErrorRetriesExhausted     = false;
    this.prerollCount                = 0;
    this.adErrorRetries              = 0; // Reset retries.
    this.currentPlacement            = 'preroll';
    this.midRollUpcoming             = false;
    this.resumingTimeStamp           = null;
    this.adFinishing                 = false;
    this.videoAdQueue                = [];
    this.baseMidrollThresholdAuction = this.midrollThresholdAuction;
    this.baseMidrollThresholdRequest = this.midrollThresholdRequest;
    this.nextMidrollThresholdAuction = this.baseMidrollThresholdAuction;
    this.nextMidrollThresholdRequest = this.baseMidrollThresholdAuction + this.baseMidrollThresholdRequest;
    this.numberOfMidrolls            = 0;

    // TODO: Not needed?
    if(this.allowAutoplay){

        this.initializeAds();
    }

    var self = this;

    // To respect ad schedule when we have one.
    if(!this.hasPlaylist || (this.hasPlaylist && this.prerollCount < this.maxPrerollAdCount)){

        // Need to wait for ads loader to be available.
        this.__adsLoaderQueue.push(function(){

            // Start next auction.
            self.requestNextAuction('preroll');
        });
    }

    if(!this.allowAutoPlaylistNavigation){

        this.logger.debug('Next mid-roll scheduled.', {
            elementId: this.elementId,
            currentTime: 0,
            numberOfMidrollsToDate: this.numberOfMidrolls,
            baseMidrollThresholdAuction: this.baseMidrollThresholdAuction,
            baseMidrollThresholdRequest: this.baseMidrollThresholdRequest,
            nextMidrollThresholdAuction: this.nextMidrollThresholdAuction,
            nextMidrollThresholdRequest: this.nextMidrollThresholdRequest,
        });
    }
};

//
// Prepares for next playback.
ValstreamVideoPlayer.prototype.prepareForNextPlayback = function(nextPlayBackDelay = 0){

    // If no ad is play or is in the queue, request next.
    if(!this.hasPlaylist && (this.hasPreparedForNextPlayback || !this.isAutoplayEnabled() || this.videoAdQueue.length !== 0 || this.adPlaying)){
        
        return;
    }
    
    if(nextPlayBackDelay){

        setTimeout(this.prepareForNextPlaybackCallback.bind(this), nextPlayBackDelay);
    }
    else{

        this.prepareForNextPlaybackCallback();
    }
}

//
// Handles ad mute button.
ValstreamVideoPlayer.prototype.handleVolumeToggle = function(event = null, context = null){

    if(context == 'mute' || (!context && this.largeSoundToggleButtonElement.classList.contains('an-vp-unmuted'))){

        this.__setVolume(0);
    }
    else if(context == 'unmute' || (!context && this.largeSoundToggleButtonElement.classList.contains('an-vp-muted'))){

        var volume = this.player.volume();

        this.__setVolume(volume);
    }
}

//
// Internal function to set volume.
ValstreamVideoPlayer.prototype.__setVolume = function(volume){
    
    // Validate volume.
    if(typeof volume !== 'number' || volume < 0 || volume > 1){

        this.logger.error('Invalid volume value provided.', {
            volume: volume,
        });

        return false;
    }

    var isMuting                                   = false;
    var cookieData                                 = 'muteStatus=unmuted; path=/';
    var adVolumeSliderLevelElementStyleWidth       = `${volume * 100}%`;
    var largeSoundToggleButtonElementClassToRemove = 'an-vp-muted';
    var largeSoundToggleButtonElementClassToAdd    = 'an-vp-unmuted';
    var adMuteElementClassToRemove                 = 'ima-muted';
    var adMuteElementClassToAdd                    = 'ima-non-muted';

    if(0 === volume){

        isMuting                                   = true;
        cookieData                                 = 'muteStatus=muted; path=/';
        adVolumeSliderLevelElementStyleWidth       = '0px';
        largeSoundToggleButtonElementClassToRemove = 'an-vp-unmuted';
        largeSoundToggleButtonElementClassToAdd    = 'an-vp-muted';
        adMuteElementClassToRemove                 = 'ima-non-muted';
        adMuteElementClassToAdd                    = 'ima-muted';
    }

    // Change player mute status.
    this.player.muted(isMuting);

    if(!isMuting){

        this.player.volume(volume);
    }

    // Set session cookie for instream only.
    if('instream' === this.videoType){

        try{

            document.cookie = cookieData;
        }
        catch(error){

            // Do nothing.
        }
    }

    if(this.googleImaAdManager && this.adPlaying){

        try{

            this.googleImaAdManager.setVolume(volume);
        }
        catch(error){

            // Do nothing.
        }
    }

    if(this.adVolumeSliderLevelElement){

        this.adVolumeSliderLevelElement.style.width = adVolumeSliderLevelElementStyleWidth;
    }

    if(this.largeSoundToggleButtonElement){
        
        this.largeSoundToggleButtonElement.classList.remove(largeSoundToggleButtonElementClassToRemove);
        this.largeSoundToggleButtonElement.classList.add(largeSoundToggleButtonElementClassToAdd);
    }

    if(this.adMuteElement){

        this.adMuteElement.classList.remove(adMuteElementClassToRemove);
        this.adMuteElement.classList.add(adMuteElementClassToAdd);
    }

    return true;
}

//
// Register event listeners.
ValstreamVideoPlayer.prototype.__registerEventListeners = function(){
    
    var self       = this;
    var handleMute = function(event){
        
        event.preventDefault(); 
        self.handleVolumeToggle(event);
    }

    // Mute button.
    this.largeSoundToggleButtonElement.addEventListener('click', this.handleVolumeToggle.bind(this));
    this.muteButtonElement.addEventListener('click', this.handleVolumeToggle.bind(this));
    this.largeSoundToggleButtonElement.addEventListener('touchend', handleMute);
    this.muteButtonElement.addEventListener('touchend', handleMute);
}

//
// Register event listeners.
ValstreamVideoPlayer.prototype.registerEventListenersOnPlay = function(){
    
    if(this.registeredEventListenersOnPlay){

        return;
    }

    this.registeredEventListenersOnPlay = true;
    var self                            = this;

    // Attach event listeners.
    this.videoContainer.addEventListener('click', function(event){

        self.handleClickEvent(event);
    });

    this.videoContainer.addEventListener('touchend', function(event){

        // To avoid duplicate event fires.
        // event.preventDefault();

        self.handleClickEvent(event);
    });

    // Add event listeners to buttons.
    this.player.controlBar.playToggle.on('click', function(event){

        // Stop auto nav on any click event.
        self.cancelAutoNav();

        if(self.player.paused()){

            self.handleClickPause();
        }
        else{

            self.handleClickPlay();
        }
    });

    this.player.controlBar.playToggle.on('touchend', function(event){

        // To avoid duplicate event fires.
        event.preventDefault();

        // Stop auto nav on any click event.
        self.cancelAutoNav();

        if(self.player.paused()){

            self.handleClickPause();
        }
        else{

            self.handleClickPlay();
        }
    });

    this.player.bigPlayButton.on('click', function(event){

        // Stop auto nav on any click event.
        self.cancelAutoNav();

        if(self.player.paused()){

            self.handleClickPause();
        }
        else{

            self.handleClickPlay();
        }
    });

    this.player.bigPlayButton.on('touchend', function(event){

        // To avoid duplicate event fires.
        event.preventDefault();

        // Stop auto nav on any click event.
        self.cancelAutoNav();

        if(self.player.paused()){

            self.handleClickPause();
        }
        else{

            self.handleClickPlay();
        }
    });


    this.player.controlBar.fullscreenToggle.on('click', function(event){

        // Stop auto nav on any click event.
        self.cancelAutoNav();
    });

    this.player.controlBar.fullscreenToggle.on('touchend', function(event){

        // To avoid duplicate event fires.
        event.preventDefault();
        
        // Stop auto nav on any click event.
        self.cancelAutoNav();
    });

    if(this.firstClickEventHandler){

        this.videoContainer.removeEventListener('click', this.firstClickEventHandler);
        this.videoContainer.removeEventListener('touchend', this.firstClickEventHandler);
    }
}

//
// Register ad event listeners.
ValstreamVideoPlayer.prototype.__registerAdEventListeners = function(){
    
    var self       = this;
    var handleMute = function(event){
        
        event.preventDefault(); 
        self.handleVolumeToggle(event);
    }

    // Mute button.
    this.adMuteElement.addEventListener('click', this.handleVolumeToggle.bind(this));
    this.adMuteElement.addEventListener('touchend', handleMute);
}

//
// Handle overlay title element hide and show.
ValstreamVideoPlayer.prototype.handleOverlayTitleElement = function(timeoutResetOnly = false, extraTime = 0) {
  
    var self = this;
            
    // Clear any existing timeouts
    if (self.titleTimeout) {
    
        clearTimeout(self.titleTimeout);
    }

    // early return to hide title and cancel any timeouts
    if(timeoutResetOnly){

        return;
    }

    // skip trigger from mouse events during ad playing and before video has started
    if(!this.adPlaying && this.player.hasStarted_) {
        
        // only for instream
        if('instream' === this.videoType){
            
            self.overlayElement.classList.remove('an-vp-int-overlay-slide-up');
            
            // Hide the title after 2 seconds + extraTime
            self.titleTimeout = setTimeout(function() {
                
                self.overlayElement.classList.add('an-vp-int-overlay-slide-up');
            }, 2000 + extraTime);
        }
    }
}

//
// Toggle autoplay.
ValstreamVideoPlayer.prototype.__toggleAutoplay = function(value){

    this.__autoplay = value;
}

//
// Enable autoplay.
ValstreamVideoPlayer.prototype.enableAutoplay = function(){
    
    this.__toggleAutoplay(true);
}

//
// Disable autoplay.
ValstreamVideoPlayer.prototype.disableAutoplay = function(){
    
    this.__toggleAutoplay(false);
}

//
// Check if autoplay is enabled.
ValstreamVideoPlayer.prototype.isAutoplayEnabled = function(){
    
    return (this.__autoplay && this.allowAutoplay);
}

ValstreamVideoPlayer.prototype.beginAdTransition = function(){

    this.playerIsTransitioning = true;

    this.videoPlayerElement.classList.add('an-vp-int-transitioning');
    this.overlayTitleElement.classList.add('an-vp-int-hidden');
    this.overlayDurationElement.classList.add('an-vp-int-hidden');
};

ValstreamVideoPlayer.prototype.endAdTransition = function(){

    this.playerIsTransitioning = false;

    this.videoPlayerElement.classList.remove('an-vp-int-transitioning');
    this.overlayTitleElement.classList.remove('an-vp-int-hidden');
};

//
// Validates text track.
ValstreamVideoPlayer.prototype.isInvalidTextTrack = function(textTrack){

    return (
        !textTrack 
        || typeof textTrack !== 'object' 
        || !textTrack.hasOwnProperty('language') 
        || !textTrack.hasOwnProperty('label') 
        || !textTrack.hasOwnProperty('url') 
        || !textTrack.hasOwnProperty('kind') 
        || !textTrack.hasOwnProperty('default')
    );
};

//
// Validates text track.
ValstreamVideoPlayer.prototype.inAdBreak = function(){

    return (this.adPlaying || this.player.ads.inAdBreak());
};

//
// Process queue of closures.
ValstreamVideoPlayer.prototype.processQueue = function(){

    var self = this;

    // Execute all closures currently in the queue.
    while(this.queue.length > 0){

        var closure = this.queue.shift();

        try{

            closure();
        }
        catch(error){

            this.logger.error('Error encountered while processing command queue.', {
                message: error.message,
                closure: closure,
            });
        }
    }

    if(this.__firstQueueProcessing){

        // Override methods to call our handler.
        // This way closures pushed to the queue will be executed immediately from this point on.
        this.queue.push = function(){

            Array.prototype.push.apply(this, arguments);
            self.processQueue();
        };

        this.queue.unshift = function(){

            Array.prototype.unshift.apply(this, arguments);
            self.processQueue();
        };

        this.__firstQueueProcessing = false;
    }
};

//
// Initialization.
ValstreamVideoPlayer.prototype.__init = function(){

    if(this.initialized){

        return;
    }

    this.initialized = true;

    //this.recordEvent('Load');
    this.recordSentinelEvent('Load');

    this.adElement = document.getElementById(this.elementId);

    if(!this.adElement){

        this.logger.error(`Unable to setup video player. Cannot find element with ID: ${this.elementId}.`);
        return;
    }

    // Check if there's already something initialized in the div.
    if(this.adElement.getElementsByTagName('video').length > 0){

        this.logger.error(`Unable to setup video player. Non-empty container element with ID: ${this.elementId}.`);
        return;
    }

    // Inject video player into target container.
    this.adElement.innerHTML = this.buildPlayerDom();

    this.videoPlayerElement = this.adElement.querySelector('.an-vp-int');

    if(!this.videoPlayerElement){
        
        this.logger.error(`Unable to setup video player. Cannot find video player element.`);
        return;
    }

    this.videoContainer = this.adElement.querySelector('.an-vp-int-c-video');

    if(!this.videoContainer){

        this.logger.error(`Unable to setup video player. Cannot find video container.`);
        return;
    }

    this.videoDetailsElement = this.adElement.querySelector('.an-vp-int-details');

    if(!this.videoDetailsElement){

        this.logger.error(`Unable to setup video player. Cannot find video details element.`);
        return;
    }

    this.overlayElement = this.adElement.querySelector('.an-vp-int-overlays');

    if(!this.overlayElement){

        this.logger.error(`Unable to setup video player. Cannot find overlay title element.`);
        return;
    }

    this.overlayTitleElement = this.overlayElement.querySelector('.an-vp-int-title');

    if(!this.overlayTitleElement){

        this.logger.error(`Unable to setup video player. Cannot find overlay title element.`);
        return;
    }

    this.overlayClickThroughButtonElement = this.overlayElement.querySelector('.an-vp-int-overlay-btn-click-through');

    if(!this.overlayClickThroughButtonElement){

        this.logger.error(`Unable to setup video player. Cannot find overlay button element.`);
        return;
    }

    this.loadingScreenElement = this.adElement.querySelector('.an-vp-int-loading-screen');

    if(!this.loadingScreenElement){

        this.logger.error(`Unable to setup video player. Cannot find loading element.`);
        return;
    }

    this.largeSoundToggleButtonElement = this.adElement.querySelector('.an-vp-btn-mute');

    if(!this.largeSoundToggleButtonElement){
        
        this.logger.error(`Unable to setup video player. Cannot find large mute button.`);
        return;
    }

    this.overlayDurationElement = this.adElement.querySelector('.an-vp-int-duration-overlay');
    
    if(!this.overlayDurationElement){
    
        this.logger.error(`Unable to setup video player. Cannot find overlay duration element.`);
        return;
    }

    this.videoContainerInner = this.videoContainer.querySelector('.an-vp-int-c-video-inner');
    this.autoNav             = this.videoContainer.querySelector('.an-vp-int-auto-nav-container');
    this.autoNavNext         = this.videoContainer.querySelector('.an-vp-int-auto-nav.an-vp-int-next');
    this.autoNavStay         = this.videoContainer.querySelector('.an-vp-int-auto-nav.an-vp-int-stay');
    this.adSkipCountdown     = this.videoContainer.querySelector(`.an-vp-int-skip-counter`);
    this.adSkipNext          = this.videoContainer.querySelector(`.an-vp-int-skip-text`);
    this.adSkipButton        = this.videoContainer.querySelector(`.an-vp-int-skip-btn`);
    this.titleElement        = this.videoDetailsElement.querySelector(`.an-vp-int-title`);
    // this.descriptionElement  = this.videoDetailsElement.querySelector(`.an-vp-int-video-description`);
    this.video               = this.videoContainer.querySelector('video');

    if(!this.videoContainerInner || !this.autoNav || !this.autoNavNext || !this.video){

        this.logger.error(`Unable to setup video player. Cannot find one or more video container elements.`, {
            videoContainerInner: this.videoContainerInner,
            autoNav: this.autoNav,
            autoNavNext: this.autoNavNext,
            video: this.video,
        });

        return;
    }

    var self = this;

    window['$vvv'] = {};

    // Init videojs.
    this.player = this.videoJsLibrary(this.video, {
        muted: (!this.__soundOn),
        autoplay: false,
        fluid: (this.MODE_LAYOUT_FLUID === this.modeLayout),
        fill: (this.MODE_LAYOUT_FILL === this.modeLayout),
        responsive: true,
        controls: true,
        aspectRatio: this.aspectRatio,
        textTrackSettings: false
    }, function(){

        var player         = this;
        var playlistVideos = [];

        if(self.playlistVideoUrls && self.playlistVideoUrls.length > 0){

            self.hasPlaylist = true;

            // Set video playlist.
            playlistVideos = self.playlistVideoUrls.map(function(url){

                return {
                    controls: true,
                    sources: [
                        {
                            src: url,
                            type: 'video/mp4',
                        },
                    ],
                }
            });
        }
        else if(self.playlist && self.playlist.length > 0){

            self.hasPlaylist = self.changePlaylist(self.playlist);
        }

        if(self.isEnabledAds()){
            var vpaidMode = 1;

            // Test insecure vpaid on TopSpeed
            if('TopSpeed' === window.adsNinjaHeaderBiddingManager.getBrandName()){
              vpaidMode = 2;
            }

            // Important to initialize IMA soon after videoJS.
            player.ima({
                debug: self.logger.isDebug(),
                prerollTimeout: (Number.isInteger(self.maxPrerollAdCount) && 0 === self.maxPrerollAdCount) ? 0 : self.prerollTimeoutInMilliseconds + 500,
                vastLoadTimeout: 10000,
                numRedirects: 10,
                disableCustomPlaybackForIOS10Plus: true,
                forceNonLinearFullSlot: true,
                autoPlayAdBreaks: (self.hasPlaylist),
                vpaidMode,
            });

            if(self.allowAutoplay){

                // *** DO NOT REMOVE *** Needed by Optimera for their targeting.
                window['$vvv']['ima'] = player.ima;
            }

            // Ads rendering settings.
            // Event will fire constantly. Event listeners need to be re-defined each time.
            player.on('ads-manager', self.adsManagerLoadedCallback.bind(self));
            player.on('ads-loader', self.adsLoaderLoadedCallback.bind(self));
        }
        else{

            self.disableAds();

            self.logger.warn('Unable to initialize IMA.', {
                player: player,
            }, false);
        }

        if(!self.allowAutoplay){

            // Instream initialization to block ad play until user clicks.
            var startEvent = 'click';

            if(navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/Android/i)
            ){

                startEvent = 'touchend';
            }

            if(self.adElement){

                self.adElement.addEventListener(startEvent, self.initializeAds.bind(self), { once: true });
            }
        }
        else{

            // *** DO NOT REMOVE *** Needed by Optimera for their targeting.
            window['$vvv']['videoJS'] = player;
        }

        // Add additional controls to videoJS.
        var volumePanel           = player.controlBar.getChild('VolumePanel');
        var fullscreenToggle      = player.controlBar.getChild('FullscreenToggle');
        var fullscreenToggleIndex = player.controlBar.children().indexOf(fullscreenToggle);
        var volumePanelIndex      = player.controlBar.children().indexOf(volumePanel);

        var nextButton = player.controlBar.addChild('button', {
            clickHandler: function(event){
                
                self.userAllowedPlayingVideos = true;

                // Stop auto nav on any click event.
                self.cancelAutoNav();

                // self.recordEvent('nextButtonClick');
                self.playlistNext();
            }
        }, volumePanelIndex);
        
        var prevButton = player.controlBar.addChild('button', {
            clickHandler: function(event){
                
                self.userAllowedPlayingVideos = true;

                // Stop auto nav on any click event.
                self.cancelAutoNav();

                // self.recordEvent('previousButtonClick');
                self.playlistPrevious();
            }
        }, volumePanelIndex);

        var skipForwardButton = player.controlBar.addChild('button', {
            clickHandler: function(event){
                
                self.userAllowedPlayingVideos = true;

                // Stop auto nav on any click event.
                self.cancelAutoNav();

                // self.recordEvent('forwardButtonClick');
                self.player.currentTime(self.player.currentTime() + 10);
            }
        }, fullscreenToggleIndex);

        var skipBackButton = player.controlBar.addChild('button', {
            clickHandler: function(event){
                
                self.userAllowedPlayingVideos = true;

                // Stop auto nav on any click event.
                self.cancelAutoNav();

                // self.recordEvent('backwardButtonClick');
                self.player.currentTime(self.player.currentTime() - 10);
            }
        }, fullscreenToggleIndex);

        prevButton.addClass('vjs-prev-button-control');
        prevButton.addClass('vjs-nav-button-control');
        nextButton.addClass('vjs-next-button-control');
        nextButton.addClass('vjs-nav-button-control');
        skipBackButton.addClass('vjs-skip-backward-control');
        skipBackButton.addClass('vjs-skip-button-control');
        skipForwardButton.addClass('vjs-skip-forward-control');
        skipForwardButton.addClass('vjs-skip-button-control');
        
        self.firstClickEventHandler = self.handleFirstClickEvent.bind(self);

        self.videoContainer.addEventListener('click', self.firstClickEventHandler);
        self.videoContainer.addEventListener('touchend', self.firstClickEventHandler);

        self.videoContainer.addEventListener('mouseenter', function(event){
        
            self.handleOverlayTitleElement();
        });

        // Stop the current ad playing and return to content.
        self.adSkipNext.addEventListener('click', function(event){

            self.handleAdSkip(self.delayAfterAdSkippedInMilliseconds);
        });

        // Stop the current ad playing and return to content.
        self.adSkipNext.addEventListener('touchend', function(event){

            // To avoid duplicate event fires.
            event.preventDefault();

            self.handleAdSkip(self.delayAfterAdSkippedInMilliseconds);
        });

        // Keep playing content.
        self.autoNavStay.addEventListener('click', function(event){

            // Stop auto nav on any click event.
            self.cancelAutoNav();
        });

        // Keep playing content.
        self.autoNavStay.addEventListener('touchend', function(event){

            // To avoid duplicate event fires.
            event.preventDefault();

            // Stop auto nav on any click event.
            self.cancelAutoNav();
        });

        // Go to next video.
        self.autoNavNext.addEventListener('click', function(event){

            self.userAllowedPlayingVideos = true;

            // Stop auto nav on any click event.
            self.cancelAutoNav();

            // self.recordEvent('nextButtonClick');
            self.playlistNext();
        });

        // Go to next video.
        self.autoNavNext.addEventListener('touchend', function(event){

            self.userAllowedPlayingVideos = true;

            // Stop auto nav on any click event.
            self.cancelAutoNav();

            // self.recordEvent('nextButtonClick');
            self.playlistNext();
        });

        // Track time on page.
        window.setInterval(function(){
            // TODO: Maybe refactor with waypoints.

            if(self.intersectedViewport){

                self.duration += 1;

                if(self.isVisible){

                    self.viewableDuration += 1;
                }
            }
        }, 1000);

        window.addEventListener('beforeunload', function(){

            // self.recordEvent('length', '', {
            //     duration: self.duration,
            // });
            // self.recordEvent('viewableDuration', '', {
            //     viewableDuration: self.viewableDuration,
            // });
        });

        // When user leaves the tab.
        // Value of isVisible is always true unless the player is closed.
        document.addEventListener('visibilitychange', function(){

            if(!self.isAutoplayEnabled() || !self.allowAutoplayWhenInView){

                return;
            }

            if(self.isVisible && document.visibilityState === 'visible' && self.adPlaying && self.isEnabledAds()){

                self.player.ima.resumeAd();
            }
            else if(self.isVisible && document.visibilityState === 'visible'){

                self.player.play();
                self.startAutoNav();
            }
            else if(self.isVisible){

                self.player.pause();
                self.cancelAutoNav();

                if(self.isEnabledAds() && self.inAdBreak()){

                    self.player.ima.pauseAd();
                }
            }
        });

        player.on('adsready', function(event){
            
            self.logger.debug('Ads ready.', {
                event: event,
            }, false);

            if(!self.hasPlaylist){

                self.player.ima.playAdBreak();

                // Track ads that never start and fail silently. Throw error after 10 seconds
                if(['SimpleFlying', 'GameRant'].indexOf(window.adsNinjaHeaderBiddingManager.getBrandName()) !== -1){
                    self.resetAdPlayTimeout();
                    self.videoPlayFailsafe = setTimeout(function() {
                        var auctionId = self.biddingManager.__getLatestAuctionId(self.elementId);
                        var auction = window.adsNinjaHeaderBiddingManager.auctions[auctionId];

                        // Get info from highest bid
                        if (auction) {
                            var prebidBids = Object.values(auction['__bidPoolPrebid']).flat();
                            var amazonBids = Object.values(auction['__bidPoolAmazon']).flat();
                            var sortedBids = [...prebidBids, ...amazonBids].sort(function(a, b) { return b.cpm - a.cpm });

                            var highestBid = sortedBids[0] || {};
                            var prefix = "prebid";
                            if (highestBid.slotID) {
                                prefix = "amazon";
                            }

                            var creativeId = `${prefix}_${highestBid.adId}`;
                            self.currentCreativeIds = [creativeId];
                        }

                        self.player.trigger({
                            type: 'adserror',
                            data: {
                                AdError: {
                                    data: {
                                        errorCode: 69,
                                        errorMessage: "Ad failed to start"
                                    }
                                }
                            }
                        });
                      }, 10000);
                  }
            }
        });

        player.on('readyforpreroll', function(event){

            self.logger.debug('Ready for Pre-roll.', {
                event: event,
            }, false);
        });

        player.on('adtimeout', function(event){

            self.logger.debug('Ad timeout.', {
                event: event,
            }, false);

            self.handleAdDone();
        });

        player.on('error', function(event){

            self.cancelAutoNav();

            self.logger.debug('Error.', {
                event: event,
            }, false);

            // Sample 5% of errors
            var sampleErrors = Math.floor(Math.random() * (100 - 1 + 1) + 1);

            if(sampleErrors < 6){

                var message      = 'Unknown error.';
                var eventMessage = event.message;

                // self.recordEvent('adError', '', {
                //     message: eventMessage || message,
                // });
            }

            // Skip to next video on video playback errors.
            if((self.intersectedViewport && self.isAutoplayEnabled()) || (self.userAllowedPlayingVideos && !self.isAutoplayEnabled())){

                self.playlistNext();
            }
            else{

                self.playlistNext(false);
            }
        });

        //
        // If some ad error occurs while trying to play an ad, retry up to 3 times to play a different ad.
        player.on('adserror', function(event){
            self.resetAdPlayTimeout();

            self.cancelAutoNav();

            self.logger.debug('Ads error.', {
                event: event,
            }, false);

            if(typeof event.getAd === 'function'){

                self.logger.debug('Ads error.', {
                    ad: event.getAd(),
                }, false);
            }

            self.biddingManager.recordAdError(event, self.currentCreativeIds, self.currentAdWrapperSystems, self.elementId);

            // Sample 5% of errors
            var sampleErrors = Math.floor(Math.random() * (100 - 1 + 1) + 1);

            if(sampleErrors < 6){

                var errorMessage = 'Unable to determine error message.';

                if(event.hasOwnProperty('data') && event.data.hasOwnProperty('AdError') && typeof event.data.AdError.getInnerError === 'function'){

                    errorMessage = event.data.AdError.getInnerError();
                }

                // self.recordEvent('adError', '', {
                //     message: errorMessage,
                // });
            }

            self.logger.debug(`Ads error, attempting to retry. Retry count: ${self.adErrorRetries}.`, {
                retryCount: self.adErrorRetries,
                event: event,
            }, false);

            var bidsAvailable = true;

            if(event.hasOwnProperty('data') && event.data.hasOwnProperty('AdError') && typeof event.data.AdError.getErrorCode === 'function'){

                bidsAvailable = (event.data.AdError.getErrorCode() !== 1009);
            }

            // Don't keep retrying when no VAST response returned. Cuts down on GAM requests.
            if(self.hasPlaylist && self.adErrorRetries < self.maxAdErrorRetries && bidsAvailable){

                // Retry ad rendering. Will not request new auction, just get next ad from existing bids.
                var videoUrl = self.biddingManager.retryPrerollAd(self.elementId);

                self.logger.debug('Retrying pre-roll ad.', {
                    elementId: self.elementId,
                    adErrorRetries: self.adErrorRetries,
                    videoUrl: videoUrl,
                });

                self.adErrorRetries += 1;

                if(videoUrl){

                    self.__renderAd(videoUrl, self.currentPlacement);
                }
            }
            else if(self.hasPlaylist){

                if(!bidsAvailable){

                      self.logger.debug('Retrying disabled, received empty VAST response.', {
                          elementId: self.elementId,
                          adErrorRetries: self.adErrorRetries,
                          maxAdErrorRetries: self.maxAdErrorRetries,
                          bidsAvailable: bidsAvailable,
                      });
                }

                if(self.adErrorRetries >= self.maxAdErrorRetries){

                    self.logger.debug('Max error retries exceeded.', {
                        elementId: self.elementId,
                        adErrorRetries: self.adErrorRetries,
                        maxAdErrorRetries: self.maxAdErrorRetries,
                        bidsAvailable: bidsAvailable,
                    });
                }

                self.adPlaying               = false;
                self.adErrorRetriesExhausted = true;

                // If in-view or user has clicked the player in a non-autoplay setting.
                if((self.intersectedViewport && self.isAutoplayEnabled()) || (self.userAllowedPlayingVideos && !self.isAutoplayEnabled())){

                    self.handleAdDone();
                    self.player.play();
                }
                else{

                    self.handleAdDone(false);
                }
            }
            else if(!self.hasPlaylist){

                self.handleAdDone();
                self.prepareForNextPlayback(self.requestDelayAdErrorInMilliseconds);
            }
        });

        // Whenever a new video starts playing, restart the auto nav process and auction.
        player.on('loadstart', function(){

            // If not first video and can play ads, show loading screen.
            if(self.isAllowedToPlayAds() && self.hasPlaylist && (self.isAutoplayEnabled() || !self.isFirstVideo)){

                self.beginAdTransition();
            }

            self.prepareForNextPlayback();
            
            // reset of video title control on new video load
            self.overlayElement.classList.remove('an-vp-int-overlay-slide-up');
            
            // trigger a timeout clear for any pending title control
            self.handleOverlayTitleElement(true);
            self.videoTitleElementIsHidden = false;
        });

        var handleTime = self.eventHelper.throttle(function(event){

            var currentTime = player.currentTime();

            if(0 === currentTime){

                return;
            }

            if(self.engagementHelper && typeof self.engagementHelper === 'object' && typeof self.engagementHelper.checkEngagement === 'function'){

                self.engagementHelper.checkEngagement();
            }

            if(self.adPlaying){

                self.adStarting = false;

                return;
            }

            if(!self.adPlaying && self.requestedTextTrack && self.requestedTextTrack.hasOwnProperty('kind') && self.requestedTextTrack.hasOwnProperty('language')){
                
                var result = self.enableTextTrack(self.requestedTextTrack.kind, self.requestedTextTrack.language);

                if(result){

                    self.requestedTextTrack = null;
                }
            }

            if(!self.trackingVideoProgressStarted && currentTime >= 1){

                self.endAdTransition();

                self.trackingVideoProgressStarted = true;

                //self.recordEvent('VideoStart');
                self.recordSentinelEvent('VideoStart');
            }

            if(!self.videoTitleElementIsHidden && currentTime >= 2){

                self.videoTitleElementIsHidden = true;
                self.handleOverlayTitleElement();
            }

            if(!self.trackingVideoProgressThresholdPassedFirst && currentTime >= 5){

                self.trackingVideoProgressThresholdPassedFirst = true;

                //self.recordEvent('Video5sec');
                self.recordSentinelEvent('Video5sec');
             }

            if(!self.trackingVideoProgressThresholdPassedSecond && currentTime >= 15){

                self.trackingVideoProgressThresholdPassedSecond = true;

                //self.recordEvent('Video15sec');
                self.recordSentinelEvent('Video15sec');
            }

             if(!self.trackingVideoProgressThresholdPassedThird && currentTime >= 30){

                self.trackingVideoProgressThresholdPassedThird = true;

                //self.recordEvent('Video30sec');
                self.recordSentinelEvent('Video30sec');
             }

             if(!self.allowAutoPlaylistNavigation && !self.midRollUpcoming && currentTime >= self.nextMidrollThresholdAuction){

                self.midRollUpcoming  = true;
                self.currentPlacement = 'midroll';
                self.numberOfMidrolls += 1;

                self.requestNextAuction(self.currentPlacement);
             }

             if(!self.allowAutoPlaylistNavigation && self.midRollUpcoming && currentTime >= self.nextMidrollThresholdRequest){

                // Try rendering ad in queue.
                if(self.tryRenderingVideoAdInQueue()){

                    // Setup for next mid-roll ad.
                    self.midRollUpcoming             = false;
                    self.baseMidrollThresholdAuction = (self.baseMidrollThresholdAuction + self.baseMidrollThresholdRequest < self.midrollIntervalMax) ? ((self.baseMidrollThresholdAuction + self.baseMidrollThresholdRequest) * self.midrollIntervalMultiplier - self.baseMidrollThresholdRequest) : self.midrollIntervalMax;
                    self.nextMidrollThresholdAuction = Math.floor(currentTime + self.baseMidrollThresholdAuction);
                    self.nextMidrollThresholdRequest = self.nextMidrollThresholdAuction + self.baseMidrollThresholdRequest;

                    self.logger.debug('Next mid-roll scheduled.', {
                        elementId: self.elementId,
                        currentTime: currentTime,
                        numberOfMidrollsToDate: self.numberOfMidrolls,
                        baseMidrollThresholdAuction: self.baseMidrollThresholdAuction,
                        baseMidrollThresholdRequest: self.baseMidrollThresholdRequest,
                        nextMidrollThresholdAuction: self.nextMidrollThresholdAuction,
                        nextMidrollThresholdRequest: self.nextMidrollThresholdRequest,
                    });
                }
             }

             if(!self.trackingVideoProgressThresholdPassedForth && currentTime >= 60){

                 self.trackingVideoProgressThresholdPassedForth = true;

                 //self.recordEvent('Video60sec');
                 self.recordSentinelEvent('Video60sec');
             }

        }, 500);

        // Whenever a new video time updates.
        player.on('timeupdate', handleTime);

        player.on('seeked', function(){

            self.logger.debug('Video seeked.', {
                event: event,
            }, false);

            self.cancelAutoNav();

            self.isSeeking = false;
            self.hasSought = true;
        });

        player.on('seeking', function(){

            self.logger.debug('Video seeking.', {
                event: event,
            }, false);

            if(!self.isSeeking){

                self.cancelAutoNav();

                self.isSeeking = true;
            }
        });

        player.on('ended', function(){

            self.logger.debug('Video ended.', {
                event: event,
            }, false);

            // self.recordEvent('videoEnded');

            if(!self.adPlaying){

                self.cancelAutoNav();
                self.playlistNext();
            }
        });

        player.on('pause', function(){

            if(self.engagementHelper && typeof self.engagementHelper === 'object' && typeof self.engagementHelper.stopTracking === 'function'){

                self.engagementHelper.stopTracking();
            }
        });

        player.on('play', function(){

            // Default elements to hide on play.
            self.overlayDurationElement.classList.add('an-vp-int-hidden');

            if(!self.trackingPlay){

                self.trackingPlay = true;

                self.registerEventListenersOnPlay();
    
                self.recordSentinelEvent('Play');
            }

            self.annonceEvent('play');

            if(!self.adPlaying && self.requestedTextTrack && self.requestedTextTrack.hasOwnProperty('kind') && self.requestedTextTrack.hasOwnProperty('language')){
                
                var result = self.enableTextTrack(self.requestedTextTrack.kind, self.requestedTextTrack.language);

                if(result){

                    self.requestedTextTrack = null;
                }
            }

            self.handleFirstClickEvent();
        });

        player.on('playing', function(){

            if(self.engagementHelper && typeof self.engagementHelper === 'object' && typeof self.engagementHelper.startTracking === 'function'){

                self.engagementHelper.startTracking();
            }

            if(!self.trackingPlay){

                self.trackingPlay = true;

                self.registerEventListenersOnPlay();
    
                self.recordSentinelEvent('Play');
            }

            // Only log once and only after ad break is confirmed to be done.
            if(!self.trackingVideoProgressStartedAfterPrerollAds && ((self.isAllowedToPlayAds() && self.prerollCount === self.maxPrerollAdCount) || !self.isAllowedToPlayAds() || self.adErrorRetriesExhausted)){

                self.trackingVideoProgressStartedAfterPrerollAds = true;

                // self.recordEvent('videoStartedAfterPrerollAds');
            }

            if(self.adFinishing && self.resumingTimeStamp !== null){

                self.adFinishing = false;

                player.currentTime(self.resumingTimeStamp);

                self.resumingTimeStamp = null;
            }

            if(!self.adPlaying && self.requestedTextTrack && self.requestedTextTrack.hasOwnProperty('kind') && self.requestedTextTrack.hasOwnProperty('language')){
                
                var result = self.enableTextTrack(self.requestedTextTrack.kind, self.requestedTextTrack.language);

                if(result){

                    self.requestedTextTrack = null;
                }
            }
        });

        if(playlistVideos && playlistVideos.length > 0){

            player.playlist(playlistVideos);

            if(self.isAutoplayEnabled()){

                player.playlist.autoadvance(1);
            }

            // Repeat when the end is reached.
            player.playlist.repeat(true);

            // Attach intersection observer for sticky functionality.
            self.observePlayer();
        }
        else if(self.hasPlaylist){

            if(self.isAutoplayEnabled()){

                player.playlist.autoadvance(1);
            }

            // Repeat when the end is reached.
            player.playlist.repeat(true);

            // Attach intersection observer for sticky functionality.
            self.observePlayer();
        }
        else{

            self.allowAutoPlaylistNavigation = false;
            self.isVisible                   = true

            player.trigger('loadstart');
        }

        self.__initialized = true;

        self.processQueue();
    });

    // Register events handlers for floating.
    this.biddingManager.registerEventHandlersForFloating(this.elementId, {
        engaged: function(height, width){

            self.handleFloatingEngaged(height, width);
        },
        disengaged: function(height, width){

            self.handleFloatingDisengaged(height, width);
        },
        disallowed: function(refloatAllowed){

            self.handleFloatingDisallowed(refloatAllowed);
        },
    });

    this.muteButtonElement = this.adElement.querySelector('.vjs-mute-control');

    if(!this.muteButtonElement){
        
        this.logger.error(`Unable to setup video player. Cannot find mute button.`);
        return;
    }
};

//
// Resets ad playing failsafe timeout and state
ValstreamVideoPlayer.prototype.resetAdPlayTimeout = function(){
    clearTimeout(this.videoPlayFailsafe);
    this.adPlaying = false;
    this.hasPreparedForNextPlayback = false;
};

ValstreamVideoPlayer.prototype.getGeo = function(){
    
    if(this.__geo === null){

        this.__geo = (this.biddingManager) ? this.biddingManager.getGeo() : null;
    }

    return this.__geo;
};

ValstreamVideoPlayer.prototype.isPrimeGeo = function(){
    
    if(this.__isPrimeGeo === null){

        this.__isPrimeGeo = (this.biddingManager) ? this.biddingManager.isPrimeGeo(this.getGeo()) : null;
    }

    return this.__isPrimeGeo;
};

window.ValstreamVideoPlayer = ValstreamVideoPlayer;
